/*================ Polyfill =============*/
Object.assign = Object.assign || function(t,j) {
  if(!j) return t;
  for(var key in j) {
    t[key] = j[key]
  }
  return t;
}
Array.prototype.contains = Array.prototype.contains || function(obj) {
  return this.indexOf(obj) !== -1;
}
if (!Array.isArray) {
  Array.isArray = function(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

String.prototype.includes = String.prototype.includes || function(search, start) {
  'use strict';
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > this.length) {
    return false;
  } else {
    return this.indexOf(search, start) !== -1;
  }
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  };
}

if(!String.prototype.escapeHTML) {
  String.prototype.escapeHTML = function() {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(this));
    return div.innerHTML;
  };
}

if(!String.prototype.handleize) {
  String.prototype.handleize = function () {
    var str = this.toLowerCase();
    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
    }

    return str
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(search, this_len) {
    if (this_len === undefined || this_len > this.length) {
      this_len = this.length;
    }
    return this.substring(this_len - search.length, this_len) === search;
  };
}


/*================ Tools ================*/
/*
 *  Browser Detection
 *    Adds class to body to help target device specific bugs.
 *
 *
 *  Version:
 *    1.0.0 - 2019/02/18
 */

$(document).ready(function() {
  if(navigator.userAgent.indexOf('Mac') > 0){
    jQuery('body').addClass('is-mac');
  }
});

/*
 *  Cart
 *    Contains common Cart related functionality and tools, including an
 *    internally managed cart.
 *
 *  Dependencies:
 *    Ensure that window.Cart.data has been injected by liquid using
 *    window.Cart.data = window.Cart.data || {{ cart | json }};
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
window.Cart = window.Cart || {};

//Queue for Cart updates
window.Cart.queue = window.Cart.queue || [];
window.Cart.triggers = window.Cart.triggers || []; //Triggers to fire after cart update.



//Add
window.Cart.add = window.Cart.add || (function(variant, qty, callback) {
  if (typeof qty === typeof undefined) qty = 1;
  var startQueue = window.Cart.queue.length === 0;

  //Setup our tracking object
  var o = {
    variant: variant,
    quantity: qty,
    callback: callback,
    task: 'add',
    data: {
      id: variant,
      quantity: qty
    }
  };

  //Create our fake callback
  o.success = function(data) {
    window.Cart.nextItem();
    if (typeof this.callback === "function") this.callback(undefined, data);
  }.bind(o);

  o.error = function(e, i) {
    console.log(e);
    if(typeof this.callback === "function") this.callback(e);
    window.Cart.queue = [];
    $(document).trigger('onCartFinished');
  }.bind(o);

  //Add to the queue
  window.Cart.queue.push(o);
  if (startQueue) window.Cart.nextItem();
});


//Remove
window.Cart.remove = window.Cart.remove || (function(index, callback) {
  var startQueue = window.Cart.queue.length === 0;
  var o = {
    index: index,
    callback: callback,
    task: 'remove',
    data: {
      line: index,
      quantity: 0
    }
  };

  o.success = function(data) {
    window.Cart.nextItem();
    if(typeof this.callback === "function") this.callback(undefined, data);
  }.bind(o);

  o.error = function(e, i) {
    console.log(e);
    if(typeof this.callback === "function") this.callback(e);
    window.Cart.queue = [];
    $(document).trigger('onCartFinished');
  }

  window.Cart.queue.push(o);
  if(startQueue) window.Cart.nextItem();
});

//Update
window.Cart.update = window.Cart.update || (function(index, quantity, callback) {
  if(typeof quantity === typeof undefined) return;
  var startQueue = window.Cart.queue.length === 0;
  var o = {
    index: index,
    callback: callback,
    task: 'update',
    data: {
      line: index,
      quantity: quantity
    }
  };

  o.success = function(data) {
    window.Cart.nextItem();
    if(typeof this.callback === "function") this.callback(undefined, data);
  }.bind(o);

  o.error = function(e, i) {
    console.log(e);
    if(typeof this.callback === "function") this.callback(e);
    window.Cart.queue = [];
    $(document).trigger('onCartFinished');
  }

  window.Cart.queue.push(o);
  if(startQueue) window.Cart.nextItem();
});





//Queue Management
window.Cart.nextItem = window.Cart.nextItem || (function() {
  if (!window.Cart.queue.length) {

    //Fire pending triggers
    for (var i = 0; i < window.Cart.triggers.length; i++) {
      var t = window.Cart.triggers[i];
      if (t == 'add') {
        $(document).trigger('onCartAdded');
      } else if(t == 'remove') {
        $(document).trigger('onCartRemoved');
      } else if(t == 'update') {
        $(document).trigger('onCartQuantityUpdated');
      }
    }

    window.Cart.triggers = [];
    $(document).trigger('onCartFinished');
    return;
  }

  //Hint we're doing something with the cart.
  $(document).trigger('onCartPending');

  //Fetch the next task
  var item = window.Cart.queue.shift();

  //Switch
  if (item.task == 'add') {
    if (window.Cart.triggers.indexOf("add") === -1) {
      window.Cart.triggers.push('add');
    }

    $.ajax({
      url: '/cart/add.js',
      method: "POST",
      dataType: "json",
      data: item.data,
      success: item.success,
      error: item.error
    });
  } else if(item.task == 'remove' || item.task == 'update') {
    if(item.task == 'remove' && window.Cart.triggers.indexOf('remove') !== -1) {
      window.Cart.triggers.push('remove');
    } else if(item.task == 'update' && window.Cart.triggers.indexOf('update') !== -1) {
      window.Cart.triggers.push('update');
    }

    $.ajax({
      url: '/cart/change.js',
      method: 'POST',
      dataType: "json",
      data: item.data,
      success: item.success,
      error: item.error
    });
  } else if (item.task == 'get') {
    $.ajax({
      url: '/cart.js',
      method: "GET",
      dataType: "json",
      success: item.success,
      error: item.error
    });
  }

  //All Done, if this has been a cart modification we're going to refetch
  //the cart to see if we have all the latest cart information that we need.
  if (item.task != 'get') {
    window.Cart.queue.push({
      task: 'get',
      success: window.Cart.onCartData,
      error: window.Cart.onCartError
    });
  }
});




window.Cart.onCartData = function(e) {
  //Semi Validate Cart
  if (typeof e === typeof undefined || typeof e.token === typeof undefined) {
    return window.Cart.onCartError(e);
  }

  //Cart is valid, first set it onto the global cart object
  window.Cart.data = e;

  //Now fire an event saying we received a cart update
  $(document).trigger('onCartUpdate', e);
  window.Cart.nextItem();
}

window.Cart.onCartError = function(a, b, c, d) {
  if (a) console.error(a);
  if (b) console.error(b);
  if (c) console.error(c);
  if (d) console.error(d);
  $(document).trigger('onCartFinished');
}

/*
 *  Currency
 *    Tools used for various currency/money related things
 *
 *  Dependencies:
 *    Recommended that window.Currency.format is set from your layout's .liquid file
 *    and injected into the window.Currency.format object
 *
 *    I also recommend window.Currency.currency is set from the layout's .liquid file
 *    as well.
 *
 *  Version:
 *    1.0.0 - 2018/02/09
 */
window.Currency = window.Currency || {};

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
window.Currency.formatMoney = function(cents, format) {
  if (typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
    cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
}

//Simple hook, this can allow for complex and custom money formatting.
window.Currency.getMoney = function(money) {
  return money;
};

/*
 *  Image Tools
 *    Provides a simple Javascript alternative to the tool.picture snippet, as
 *    well as some nice Shopify Image tools for use in Javascript
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
window.ImageTools = window.ImageTools || {};

window.ImageTools.getImageURL = window.ImageTools.getImageURL || (function(src,size) {
  src = src || "";
  src = src.split('?');
  src = src[0];

  size = "" + size;
  if(!size.endsWith("x")) size += "x";

  var removeProtocol = function(path) {
    return path.replace(/http(s)?:/, '');
  };

  if (size === null) {
    return src;
  }
  if (size === 'master') {
    return removeProtocol(src);
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return removeProtocol(prefix[0] + '_' + size + suffix);
  } else {
    return null;
  }
});

window.ImageTools.generatePicture = window.ImageTools.generatePicture || (function(image, width, sizes, clazz, alt) {
  if(typeof width === typeof undefined || !width) width = 1400;
  if(typeof sizes === typeof undefined || !sizes || !sizes.length) sizes =  [500, 750, 1000];
  if(typeof alt === typeof undefined || !alt) alt = null;

  var ratios = [1, 2, 4];

  //TODO: Maybe we can enable some way of fetching the information about the
  //image here. (Mainly the image src, alt and dimensions if we can)
  var x = '<picture>';
  for(var i = 0; i < sizes.length; i++) {
    var s = sizes[i];
    x += '<source media="(';
    if(i != (sizes.length-1)) {
      x += 'max-width';
    } else {
      x += 'min-width';
    }

    x += ':'+s+'px)" srcset="';
    for(var y = 0; y < ratios.length; y++) {
      var r = ratios[y];
      x += window.ImageTools.getImageURL(image, s * r);
      if(r != 1) x += ' ' + r + 'x';
      if(y < (ratios.length-1)) y += ', ';
    }
    x += '" '
    if(alt) x += 'alt="'+alt+'" '
    x += '/>'
  }

  x += '<img src="'+window.ImageTools.getImageURL(image, width)+'" ';
  if(alt) x += 'alt="'+alt+'" ';
  if(clazz) x += 'class="'+clazz+'" ';
  x += '/>';
  x += '</picture>';
  return x;
});

/*
 *  Language
 *    Tools for Language options in Javascript
 *
 *  Dependencies:
 *    Add any used language keys to the widnow.Language.strings object.
 *
 *    I'm still toying with the idea of changing languages on the fly, I will look into this.
 *
 *  Version:
 *    1.0.0 - 2018/02/22
 */
window.Language = window.Language || {};
window.Language.strings = window.Language.strings || {};

//Mark a certain string as required, will display a handy debugging alert if it's not
window.Language.required = window.Language.required || (
  function(x) {
    if(typeof window.Language.strings[x] !== typeof undefined) return;
    $(document.body).prepend('<div style="position:fixed;top:0;left:0;background:red;color:white;z-index:9999999">Missing translation key ' + x + '</div>');//Temporarily disabled until I can think of a better solution
  }
);

window.Language.get = window.Language.get || (
  function(x) {
    return window.Language.strings[x] || 'Missing translation key ' + x;
  }
);

/*
 *  Query
 *    Tools used for reading/writing/manipulating the query string.
 *
 *  Dependencies:
 *
 *  Version:
 *    1.0.0 - 2018/02/12
 */

window.query = window.query || {};
window.queryTools = window.queryTools || {};

window.queryTools.decodeSearch = function(search) {
  var o = {};
  for (var aKeyValue, i = 0, aCouples = search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if(aKeyValue.length > 1) {
      o[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
  return o;
}

window.queryTools.setValue = function(name, value, updateHistory) {
  if(typeof updateHistory === typeof undefined) updateHistory = true;

  window.query[name] = value;

  if(updateHistory) {
    //Updates the query to have the new value and also updates the history object.
    var s = '?';
    var keys = Object.keys(window.query);
    for(var i = 0; i < keys.length; i++) {
      var k = keys[i];
      s += encodeURIComponent(k)+'='+encodeURIComponent(window.query[k]);
      if(i < keys.length-1) s += '&';
    }
    history.pushState(null, '', s);
  }
}


//Read the query string.
if(location.search.length) {
  window.query = window.queryTools.decodeSearch(location.search);
}


/*================ Objects ================*/
/*
 *  Accordion
 *    Scripts for accordion sliders
 *
 *  Dependencies:
 *    jQuery - jQuery is required for event listeners
 *    styles/objects/_accordion.scss - Styles for the accordion
 *
 *  Version:
 *    1.0.0 - 2018/02/12
 */
function Accordion(container) {
  this.container = container;
  this.id = (window.accordions = window.accordions || []).length;
  this.container.attr('data-id', this.id);
  this.slides = this.container.find('[data-accordion-slide]');

  this.multiple = this.container.data('multiple') || false;

  //Asign indicies
  this.slides.each(function(e) {
    var self = $(this);
    self.attr('data-id', e);
    self.find('[data-accordion-title]').attr('data-id', e);
  });

  //Event Handlers
  this.container.on('click', '[data-accordion-title]', this.changeSlide.bind(this));
}

Accordion.prototype = {
  changeSlide: function(e, b) {
    if(this.container === typeof undefined) return;
    var self = $(e.currentTarget);
    var index = self.data('id');
    if(typeof index === typeof undefined) return;
    this.setSlide(index);
  },

  getSlideByIndex: function(index) {
    return this.container.find('[data-accordion-slide][data-id="'+index+'"]');
  },

  setSlide: function(index) {
    var slide = this.getSlideByIndex(index);

    //console.log(slide);

    if(slide.attr('data-expanded') == "true") {
      //Already expanded, just shrink this one
      slide.removeClass('is-expanded');
      slide.attr('data-expanded', false);
    } else {
      if(!this.multiple) {
        //this.slides.removeClass('is-expanded');
        //this.slides.attr('data-expanded', false);
      }
      slide.addClass('is-expanded');
      slide.attr('data-expanded', true);
    }

    this.onExpand(index, slide);
  },

  onExpand: function(index, slide) {

  }
}

$(document).ready(function() {
  $('[data-accordion]').each(function() {
    var self = $(this);
    var accordion = new Accordion(self);
    window.accordions = window.accordions || [];
    window.accordions.push(accordion);
  });
});

/*
 *  Currency Selector for Shopify Plus
 *    Scripts for a simple currency selector
 *
 *
 *  Version:
 *    2.0.0 - 2018/08/22
 */


$('.shopify-currency-form select').on('change', function() {
  $(this)
    .parents('form')
    .submit();
});

/*
 *  Quantity Selector
 *    Quantity Selector. Please note that this has no logic and is designed to
 *    be implemented by a subclass (e.g. a Product Page Quantity Selector, or
 *    a Cart Page Quantity Selector)
 *
 *  Version:
 *    1.0.0 - 2018/07/29
 */
function QuantitySelector(container) {
  this.container = container;

  //Elements
  this.addButton = container.find('[data-quantity-selector-plus]');
  this.minusButton = container.find('[data-quantity-selector-minus]');
  this.input = container.find('[data-quantity-selector-input]');

  //Listeners
  container.on('click', '[data-quantity-selector-minus]', this.onMinusClick.bind(this) );
  container.on('click', '[data-quantity-selector-plus]', this.onAddClick.bind(this) );
  container.on('blur', '[data-quantity-selector-input]', this.onBlur.bind(this));

  //Internals
  this.fixIntegers();
  this.previousValue = this.getValue();
  this.updateButtonStates();
}

QuantitySelector.prototype = {
  getValue: function() {
    var v = parseInt(this.input.val());
    if(isNaN(v)) v = 0;
    if(!isFinite(v)) v = 0;
    if(v < this.getMin()) v = this.getMin();
    if(v > this.getMax()) v = this.getMax();
    if(!isFinite(v)) v = 0;
    return v;
  },

  getMin: function() {
    return this.input.attr('data-quantity-selector-input-min') || Number.NEGATIVE_INFINITY;
  },

  getMax: function() {
    return this.input.attr('data-quantity-selector-input-max') || Number.INFINITY;
  },

  onMinusClick: function(e) {
    e.preventDefault();
    e.stopPropagation();
    this.modify(-1);
  },

  onAddClick: function(e) {
    e.preventDefault();
    e.stopPropagation();
    this.modify(1);
  },

  onBlur: function() {
    this.fixIntegers();
    var val = this.getValue();
    this.set(val);
  },

  modify: function(amt) {
    this.fixIntegers();
    var val = this.getValue();
    val += amt;
    this.set(val);
  },

  set: function(v) {
    if(isNaN(v)) v = 0;
    if(!isFinite(v)) v = 0;
    if(v < this.getMin()) v = this.getMin();
    if(v > this.getMax()) v = this.getMax();
    if(!isFinite(v)) v = 0;

    this.input.val(v);

    //Update the button states
    this.updateButtonStates();

    //Trigger an update event?
    if(this.previousValue == v) return;

    if(v > this.previousValue) {
      this.onAdd(v);
    } else {
      this.onMinus(v);
    }
    this.onChange(v);
  },

  fixIntegers: function() {
    var v = this.getValue();
    if(parseInt(this.input.val()) != v) {
      this.input.val(v);
    }
  },

  updateButtonStates: function() {
    var v = this.getValue();
    if(v == this.getMin()) {
      this.minusButton.attr('disabled', 'disabled');
    } else {
      this.minusButton.removeAttr('disabled');
    }

    if(v == this.getMax()) {
      this.addButton.attr('disabled', 'disabled');
    } else {
      this.addButton.removeAttr('disabled');
    }
  },

  //Events (you can sub these methods)
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {}
};

/*
 *  Variant Selector
 *    Provides basic functionality for the variant selector
 *
 *  Dependencies:
 *    scripts/tools/query.js
 *    scripts/tools/language.js - Required for messasges.
 *    scripts/tools/currency.js - Required for money.
 *    snippets/variant-selector.liquid
 *
 *  Version:
 *    2.0.0 - 2018/07/30
 */
window.Language.required('products.product.add_to_cart');
window.Language.required('products.product.sold_out');

//Common Functions
window.VariantSelector = window.VariantSelector || {};
window.VariantSelector.getVariantData = window.VariantSelector.getVariantData || (function(variant) {
  var data = JSON.parse( $('[data-product-json]').html() );
  //Get the variant value
  var variantData;
  for(var i = 0; i < data.variants.length; i++) {
    var v = data.variants[i];
    if(v.id != variant) continue;
    variantData = v;
    break;
  }
  return variantData;
});



//Track changes to the selector
$(document).on('change', '[data-product-select]', function(e) {
  var self = $(this);
  var variant = self.val();
  var variantData = window.VariantSelector.getVariantData(variant);
  if(typeof variantData === typeof undefined) return;
  
  $(document).trigger('onVariantChange',[variant,variantData]);
});

//Track events
$(document).on('onVariantChange', function(e, variant, variantData) {
  //Update Selectors
  $('[data-product-select]').val(variant);
  
  //Update the URL
  window.queryTools.setValue('variant', variant);

  //Update product details
  var price = variantData.price;
  var priceEasy = price / 4.0;
  console.log("priceEasy", priceEasy);
  var moneyElement = $('[data-product-money]');
  var moneyElementEasy = $('[data-product-money-easy]');
  moneyElement.attr('data-money', price);
  moneyElementEasy.attr('data-money-easy', priceEasy);
  moneyElement.html(window.Currency.formatMoney(price));
  moneyElementEasy.html(window.Currency.formatMoney(priceEasy));
  moneyElement.trigger('onMoneyChange', price);
  moneyElementEasy.trigger('onMoneyChange', priceEasy);

  //Compare at price. Please note this logic is replicated in the
  //product-pricing.liquid snippet, please ensure all logic changes made here
  //are replicated there.
  var comparePrice = variantData.compare_at_price;
  var compareMoneyElement = $('[data-product-compare-money]');
  if(comparePrice > price) {
    compareMoneyElement.attr('data-money', comparePrice);
    compareMoneyElement.html(window.Currency.formatMoney(comparePrice));
    compareMoneyElement.trigger('onMoneyChange', comparePrice);
  } else {
    compareMoneyElement.removeAttr('data-money');
    compareMoneyElement.html('');
  }

  //Update Add To Cart Button
  var addToCart = $('[data-add-to-cart]');
  if(variantData.available) {
    addToCart.removeAttr('disabled');
    addToCart.html(window.Language.get('products.product.add_to_cart'));
  } else {
    addToCart.attr('disabled', 'disabled');
    addToCart.html(window.Language.get('products.product.sold_out'));
  }

  //update Afterpay
  var afterpayPrice = Math.ceil(price/4);
  $('[data-afterpay-payment]').html(window.Currency.formatMoney(afterpayPrice, '${{amount}}'));

  //Variant Image ID
  if(!variantData || !variantData.featured_media || !variantData.featured_media.id) return;
  var imageId = variantData.featured_media.id;
  var target = $('.slick-slide[data-image-id='+imageId+']');
  if(!target.hasClass('slick-current')) target.trigger('click');

});

//History Event
window.onpopstate = function(event) {
  var t = event.target;
  var o = window.queryTools.decodeSearch(t.location.search);

  if(typeof o.variant === typeof undefined || !o.variant.length) return;
  if($('[data-product-select]').val() == o.variant) return;

  var variantData = window.VariantSelector.getVariantData(o.variant);
  if(typeof variantData === typeof undefined) return;

  $(document).trigger('onVariantChange',[o.variant,variantData]);
};

/*
 *  Product Page Quantity Selector
 *    Quantity Selector for a product page.
 *
 *  Dependencies:
 *    scripts/objects/_quantity-selector.js
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
function ProductPageQuantitySelector(container) {
  QuantitySelector.call(this, container);
}

//Inherit
ProductPageQuantitySelector.prototype = Object.assign(Object.assign(Object.assign({}, QuantitySelector.prototype), ProductPageQuantitySelector.prototype), {
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {
    $('[name="quantity"]').val(this.getValue());
  },
});

//Finalize Inheritence
ProductPageQuantitySelector.prototype.constructor = ProductPageQuantitySelector;

//TODO: Add support for max that can be added to the cart, this is limited due
//to the fact that the product JSON does not contain the max inventory (maybe a
//good idea)

//Attach
$(document).ready(function() {
  $('[data-product-page-quantity-selector]').each(function() {
    var self = $(this);
    new ProductPageQuantitySelector(self);
  });
});

/*
 *  Cart Quantity Selector
 *    Quantity selector for use on the cart line items
 *
 *  Dependencies:
 *    scripts/objects/_quantity-selector.js
 *    scripts/tools/cart.js
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
function CartQuantitySelector(container) {
  QuantitySelector.call(this, container);

  this.lineItemId = this.container.attr('data-line-item-id');
  this.lineItemIndex = this.container.attr('data-line-item-index');
}

//Inherit
CartQuantitySelector.prototype = Object.assign(Object.assign(Object.assign({}, QuantitySelector.prototype), CartQuantitySelector.prototype), {
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {
    var value = this.getValue();
    if(value == 0) {
      //Remove from the Cart
      window.Cart.remove(this.lineItemIndex);
    } else {
      window.Cart.update(this.lineItemIndex, value);
    }
  },
});

//Finalize Inheritence
CartQuantitySelector.prototype.constructor = CartQuantitySelector;

//TODO: Add support for max that can be added to the cart, this is limited due
//to the fact that the product JSON does not contain the max inventory (maybe a
//good idea)

//Attach
$(document).ready(function() {
  $('[data-cart-quantity-selector]').each(function() {
    var self = $(this);
    window.cartQuantitySelector = new CartQuantitySelector(self);
  });
});

/*
 *  Swatch
 *    Product Swatch Controls (does not handle standard variants)
 *
 *  Dependencies:
 *    snippets/product-swatches.liquid
 *    scripts/objects/variant-selector.js
 *    jQuery
 *
 *  Version:
 *    1.2.0 - 2018/10/12
 */
window.swatch = {
  setVariantFromSwatch: function(el, value) {
    //Triggers a standard variant change based on a swatch
    var position = el.attr('data-swatch-position');

    var currentSelection = $('[data-variant-option]:selected');

    var selector = '[data-variant-option]';

    //Ok so I was running into a problem regarding multiple levels of variants
    //And this is caused by non standard variants
    //e.g. if a product has the variants:
    // Material Cloth, Color Red
    // Material Cloth, Color Blue
    // Material Silk, Color Red
    // Material Silk, Color Green
    //It will show the color green even if the material is currently cloth, and
    //Will fail to select the variant if there's.. yada yada etc etc basically
    //we need to only show variant subs for variants of top level-ness
    var optionCount = currentSelection.attr('data-option-count');
    var target;

    for(var i = 1; i <= optionCount; i++) {
      var selectorValue;
      if(i == position) {
        //This is the value we've updated.
        selectorValue = value;
      } else {
        var existingValue = currentSelection.attr('data-option'+i);
        if(typeof existingValue === typeof undefined) continue;
        selectorValue = existingValue;
      }

      var selectorTemp = ""+selector;//Temporary "previous" storage
      selector += '[data-option'+i+'="'+selectorValue+'"]';
      //Ok now we're going to check if the variant we're after exists
      var target = $(selector);
      if(!target.length) {
        //Okay so the selector we're targetting isn't valid for the new selection
        //So that means that we have to just find the first of its kind
        selector = selectorTemp + '[data-option'+i+']:first';
        target = $(selector);
      }
    }

    //Find the variant ID based from the selection
    var targetValue = target.val();
    var targetData = window.VariantSelector.getVariantData(targetValue);
    if(typeof targetData === typeof undefined) return;
    $(document).trigger('onVariantChange',[targetValue,targetData]);
  },

  updateAvailableSwatches: function(variant) {
    //Now decide what we're going to hide and show in terms of swatches.
    var option = $('[data-variant-option][value="'+variant+'"]');
    var optionCount = option.attr('data-option-count');
    var jsonElement = $('[data-product-json]');
    if(!jsonElement.length) return;
    var data = JSON.parse( jsonElement.html() );
    var selectedVariant;
    for(var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if(v.id != variant) continue;
      selectedVariant = v;
      break;
    }
    if(!selectedVariant) return;

    //Begin hiding
    $('[data-swatch]').addClass('is-hidden');
    $('[data-swatch]').addClass('is-sold-out');
    $('[data-swatch-selector] option').attr('disabled', 'disabled');

    //Top level are always available
    $('[data-swatch][data-swatch-position="1"]').removeClass('is-hidden');
    $('[data-swatch-selector][data-swatch-position="1"] option').removeAttr('disabled');

    for(var i = 2; i <= optionCount; i++) {
      //Given the selected previous level, what options for *this* level are available?
      var prevOption = selectedVariant["option"+(i-1)];
      var allowedOptionsForThisLevel = [];
      for(var x = 0; x < data.variants.length; x++) {
        var v = data.variants[x];
        var n = v["option"+i];
        if(allowedOptionsForThisLevel.indexOf(n) !== -1) continue;
        if(v["option"+(i-1)] != prevOption) continue;
        allowedOptionsForThisLevel.push(n);
      }

      for(var x = 0; x < allowedOptionsForThisLevel.length; x++) {
        var ao = allowedOptionsForThisLevel[x];
        if(ao) ao = ao.toLowerCase();
        $('[data-swatch][data-swatch-position="'+i+'"][data-value="'+ao+'"]').removeClass('is-hidden');
        $('[data-swatch-selector][data-swatch-position="'+i+'"] [value="'+ao+'"]').removeAttr('disabled');
      }
    }

    //Now determine what's sold out for each given level
    for(var i = 1; i <= optionCount; i++) {
      var avail = {};//Stores availability of option[i]'s value.

      //Find if there are any variants for this option with stock available
      for(var x = 0; x < data.variants.length; x++) {
        var v = data.variants[x];
        //Check previous options match, since we don't want to check stock of
        //other levels
        var canUse = true;
        for(var y = 1; y < i; y++) {
          if(v['option'+y] == selectedVariant['option'+y]) continue;
          canUse = false;
          break;
        }
        if(!canUse) continue;

        var n = v["option"+i];
        if(typeof avail[n] === typeof undefined) avail[n] = v.available;
        avail[n] = avail[n] || v.available;
      }

      //Now remove these as sold out.
      var keys = Object.keys(avail);
      for(var x = 0; x < keys.length; x++) {
        var k = keys[x];
        var v = avail[k];
        if(!v) continue;
        $('[data-swatch][data-swatch-position="'+i+'"][data-value="'+k.toLowerCase()+'"]').removeClass('is-sold-out');
      }
    }
  }
};

//Swatch Listeners
$(document).on('click', '[data-swatch]', function(e) {
  var self = $(this);
  window.swatch.setVariantFromSwatch(self, self.attr('data-value'));
});

$(document).on('change', '[data-swatch-selector]', function(e) {
  var self = $(this);
  window.swatch.setVariantFromSwatch(self, self.val());
});

$(document).ready(function() {
  var currentSelection = $('[data-variant-option]:selected');
  window.swatch.updateAvailableSwatches(currentSelection.attr('value'));
});

//Variant Listeners
$(document).on('onVariantChange', function(e, variant, variantData) {
  var option = $('[data-variant-option][value="'+variant+'"]');
  var optionCount = option.attr('data-option-count');

  $('[data-swatch]').removeClass('is-selected');

  //Now decide what we're going to hide and show in terms of swatches.
  window.swatch.updateAvailableSwatches(variant);

  for(var i = 1; i <= optionCount; i++) {
    var val = option.attr('data-option'+i);
    if(val) val = val.toLowerCase()
    var s = $('[data-swatch][data-swatch-position="'+i+'"][data-value="'+val+'"]');
    s.addClass('is-selected');
    $('[data-swatch-selector][data-swatch-position="'+i+'"]').val(val);

    var display = variantData['option'+i];
    if(s.attr('data-label')) display = s.attr('data-label').escapeHTML();
    $('[data-swatch-value][data-swatch-position="'+i+'"]').html(display);
  }
});



/*================ Components ================*/
/*** Import Filters ***/
function AjaxCollectionFilter(handle, collection) {
  this.handle = handle;
  this.collection = collection;
}

AjaxCollectionFilter.prototype = {
  getSettings: function() {
    //Return a list (either array or object) of all this filters' settings.
  },

  getSetting: function(key) {
    //Returns the setting specified by key (it's current value)
  },

  setSetting: function(key, value) {
    //Set the value at key with the value; value
  },

  setSettings: function(settings) {
    //Same as above but for all settings at once
  },

  filter: function(product, variant) {
    //Your custom filter may super this method.
    //Retrurn true to keep this product, false to remove.
    return true;
  },

  init: function(settings) {
    //Init with the default settings, shouldn't be sub called, designed to use
    //whatever settings are defined at a collection level.
    if(typeof settings === typeof undefined || !settings) return;
    this.setSettings(settings);
  }
};

/*
 *  AjaxCollectionTagFilter
 *    Designed to take in an array of tags to filter the products by.
 *    Can be used in either AND or OR operation.
 *
 *    IMPORTANT NOTE!!!!! ALL TAGS WILL BE CONVERTED TO LOWERCASE!!
 *
 *    AND Example:
 *      Product A has tags "Red", "Green" and "Blue"
 *      Product B has tags "Red", "Orange", "Blue" and "Brown"
 *      Results when setting the filter tags to...:
 *        ["Red", "Green"] = Product A will show, not B
 *        [ "Red" ] = Both A and B will show
 *        [ "Red", "Blue" ] = Both A and B
 *        [ "Brown" ] = Only B will show
 *        [ "Green", "Orange" ] = Neither will show
 *
 *    OR Example:
 *      Same example as above except results will be...
 *        ["Red", "Green"] = Both A and B will show
 *        [ "Red" ] = Both A and B will show
 *        [ "Red", "Blue" ] = Both A and B
 *        [ "Brown" ] = Only B will show
 *        [ "Green", "Orange" ] = Both A and B will show
 *        [ "Purple" ] = Neither will show
 */
function AjaxCollectionTagFilter(handle, collection, operation, tags) {
  AjaxCollectionFilter.call(this, handle, collection);

  //Params Default
  if(typeof operation === typeof undefined) operation = "AND";
  if(typeof tags === typeof undefined) tags = [];

  //Tag arrays
  this.tags = tags;
  this.operation = operation;//Can be AND or OR.
}

//Extend the base filter object.
AjaxCollectionTagFilter.prototype = Object.assign(AjaxCollectionTagFilter.prototype, AjaxCollectionFilter.prototype);
AjaxCollectionTagFilter.prototype = Object.assign(AjaxCollectionTagFilter.prototype, {

  //Set Operation, can be either AND or OR, used for tag comparison
  setOperation: function(and_or_or) {
    this.operation = and_or_or;
    this.collection.onFilterUpdate();
  },


  //Add a tag to this filter, also forces an update
  addTag: function(tag) {
    tag = tag.toLowerCase();
    if(this.tags.indexOf(tag) !== -1) return;
    this.tags.push(tag);

    this.collection.onFilterUpdate();
  },

  //Remove a tag from this filter, forces an update
  removeTag: function(tag) {
    tag = tag.toLowerCase();
    var index = this.tags.indexOf(tag);
    if(index === -1) return;
    this.tags.splice(index, 1);

    this.collection.onFilterUpdate();
  },

  //Get all settings, in this case we're returning an array of tags that this
  //filter is.. filtering by.
  getSettings: function() {
    return this.tags;
  },

  //Get an individual setting (tag, either true or false if restricted)
  getSetting: function(tag) {
    tag = tag.toLowerCase();
    if(typeof tag === typeof undefined) return this.tags;
    return this.tags.indexOf(tag) !== -1;
  },

  //Set a setting, if true it will add that tag to this filter, if false it will
  //remove it.
  setSetting: function(key, value) {
    if(value) return this.addTag(key.toLowerCase());
    this.removeTag(key);
  },

  //Set an array of tags (or pass a single tag) and it will force an update
  setSettings: function(settingSet) {
    if(!Array.isArray(settingSet)) settingSet = [ settingSet ];
    this.tags = settingSet;
    this.collection.onFilterUpdate();
  },

  //Filtering Function, called for every product and variant that is going to be
  //printed.
  filter: function(product, variant) {
    //If we're not filtering by any tags, just return
    if(!this.tags.length) return true;//No filtering

    //For each tag in this filter...
    var hasAnyTag = false;
    for(var i = 0; i < this.tags.length; i++) {
      //For each tag in product...
      var filterTag = this.tags[i];
      var filterTagLower = filterTag.toLowerCase();
      var hasThisTag = false;

      for(var x = 0; x < product.tags.length; x++) {
        var productTag = product.tags[x];
        var productTagLower = productTag.toLowerCase();
        if(filterTagLower != productTagLower) continue;//Case insensitive.
        hasThisTag = true;
        hasAnyTag = true;
        break;
      }

      //Now the magic
      if(this.operation == "AND" && !hasThisTag) {
        //Since AND Requires every one of this filters' tags, we can safely exit
        //if it's missing even a single tag
        return false;
      } else if(this.operation == "OR" && hasThisTag) {
        //Since OR allows us to have any of the tags we can safely exit!
        return true;
      }
    }

    //Since the above methods are inverted for OR vs AND, we need to change our
    //default return method.

    //OR Above will return for any tag, but the default needs to be false
    //AND Above will return false if it's missing any tag, but the default
    //(all tags) must be true
    if(this.operation == "AND") {
      return true;
    } else if(this.operation == "OR") {
      return false;
    }
  }
});

/*
 *  AjaxCollectionColorFilter
 *    Designed to take a set of colors to filter by. Note this will assume you
 *    have setup color swatches!!! Ensure you're using all the necessary items
 *    for color swatches.
 *
 *  Dependencies:
 *    scripts/objects/_swatch.js
 *
 *  Version:
 *    1.0.0 - 2018/08/14
 */
function AjaxCollectionColorFilter(handle, collection, operation, colors) {
  AjaxCollectionFilter.call(this, handle, collection);

  //Params Default
  if(typeof operation === typeof undefined) operation = "AND";
  if(typeof colors === typeof undefined) colors = [];

  this.colors = colors;
  this.operation = operation;//Can be AND or OR.
}
AjaxCollectionColorFilter.prototype = Object.assign(AjaxCollectionColorFilter.prototype, AjaxCollectionFilter.prototype);
AjaxCollectionColorFilter.prototype = Object.assign(AjaxCollectionColorFilter.prototype, {
  //Adjust Operation of filter
  setOperation: function(and_or_or) {
    this.operation = and_or_or;
    this.collection.onFilterUpdate();
  },

  //Manage Colors
  addColor: function(color) {
    if(this.colors.indexOf(color) !== -1) return;
    this.colors.push(color);

    this.collection.onFilterUpdate();
  },

  removeColor: function(color) {
    var index = this.colors.indexOf(color);
    if(index === -1) return;
    this.colors.splice(index, 1);

    this.collection.onFilterUpdate();
  },


  //Retrieve Settings
  getSetting: function(color) {
    return this.colors.indexOf(color) !== -1;
  },

  getSettings:function() {
    return this.colors;
  },


  //Adjust settings
  setSetting: function(key, value) {
    if(value) return this.addColor(key);
    this.removeColor(key);
  },

  setSettings: function(settingSet) {
    if(!Array.isArray(settingSet)) settingSet = [ settingSet ];
    this.colors = settingSet;
  },


  //Filtration
  filter: function(product, variant) {
    //Are we filtering by any colors?
    if(!this.colors.length) return true;
    if(typeof window.Swatches === typeof undefined) {
      console.error("A color filter was found, but no Swatches object exists on the window!");
      console.error("Make sure you're using the latest version of the swatches before continuing");
      return true;
    }

    //First we have to determine the color option index. This is the index of the
    //option (e.g. Size, Color, Material will have option index 1 for color)
    //so we can reference the value in the variant, e.g. "XL", "Red", "Cotton"...
    var colorIndex = this.collection.getOptionIndex(product, ['Color', 'Colour']);
    if(colorIndex === -1) return false;//No Color

    //Check variant color exists
    var variantColor = variant.options[colorIndex].handleize();
    if(!variantColor || !variantColor.length) return false;

    //Iterate over the colors
    for(var i = 0; i < this.colors.length; i++) {
      var color = this.colors[i];
      var swatch = null;
      //Fetch the swatch object that this color belongs to
      for(var x = 0; x < window.Swatches.length; x++) {
        if(window.Swatches[x].name != color) continue;//Case sensitive
        swatch = window.Swatches[x];
        break;
      }

      if(!swatch) {
        console.error("Couldn't find swatch for filter " + color);
        continue;
      }

      //Now find the handle that this color may belong to.
      var colorHandle = null;
      for(var x = 0; x < swatch.handles.length; x++) {
        var handle = swatch.handles[x];
        //CASE SENSITIVE
        if(handle != variantColor) continue;
        colorHandle = handle;
        break;
      }

      //Now we have a valid color, and it matches what we're filtering by!
      if(this.operation == "AND" && !colorHandle) {
        return false;//Does not have this color!
      } else if(this.operation == "OR" && colorHandle) {
        return true;//Has this color!
      }
    }

    //By default if we get to here then AND must have been successful, but if
    //it's OR it means it wasn't.
    if(this.operation == "AND") {
      return true;
    } else if(this.operation == "OR") {
      return false;
    }
  }
});

function AjaxCollectionGroupFilter(handle, collection, operation, filters) {
  AjaxCollectionFilter.call(this, handle, collection);

  if(typeof operation === typeof undefined) operation = "AND";
  if(typeof filters === typeof undefined) filters = [];

  this.operation = operation;//Operation
  this.filters = filters;//Sub filters
}

AjaxCollectionGroupFilter.prototype = Object.assign({}, AjaxCollectionFilter.prototype);

AjaxCollectionGroupFilter.prototype.addFilter = function(filter) {
  if(this.filters.indexOf(filter) === -1) return;
  this.filters.push(filter);
  this.collection.onFilterUpdate();
}

AjaxCollectionGroupFilter.prototype.removeFilter = function(filter) {
  var index = this.filters.indexOf(filter);
  if(index === -1) return;
  this.filters.splice(index, 1);

  this.collection.onFilterUpdate();
}

AjaxCollectionGroupFilter.prototype.filter = function(product, variant) {
  //No Filters?
  if(!this.filters.length) return true;

  for(var i = 0; i < this.filters.length; i++) {
    var filter = this.filters[i];
    var result = filter.filter(product,variant);

    //Now the magic
    if(this.operation == "AND" && !result) {
      return false;
    } else if(this.operation == "OR" && result) {
      return true;
    }
  }

  //Default return (changes depending on OR vs AND)
  if(this.operation == "AND") {
    return true;
  } else if(this.operation == "OR") {
    return false;
  }
}

/*
 *  AjaxCollectionPriceFilter
 *    Filtering of variants by a price range.
 *
 *  Version:
 *    1.0.0 - 2018/10/11
 */
function AjaxCollectionPriceFilter(handle, collection) {
  AjaxCollectionFilter.call(this, handle, collection);

  //Setup the price min and max ranges
  this.min = -1;
  this.max = -1;
}

AjaxCollectionPriceFilter.prototype = Object.assign(AjaxCollectionPriceFilter.prototype, AjaxCollectionFilter.prototype);
AjaxCollectionPriceFilter.prototype = Object.assign(AjaxCollectionPriceFilter.prototype, {
  getSettings: function() {
    var o = {};
    if(this.min != -1) o.min = this.min;
    if(this.max != -1) o.max = this.max;
    return o;
  },

  getSetting: function(key) {
    if(key == 'min' && this.min != -1) return this.min;
    if(key == 'max' && this.max != -1) return this.max;
  },

  setSettings: function(settings) {
    this.min = settings.min || 0;
    this.max = Math.ceil(settings.max) || 0;
  },

  setSetting: function(key) {
    if(key == 'min') return this.min = key;
    if(key == 'max') return this.max = Math.ceil(key);
  },

  filter: function(product, variant) {
    //Are we filtering by price at all?
    if(this.min == -1 && this.max == -1) return true;
    //Are we filtering by min price?
    if(variant.price < this.min) return false;

    //Are we filtering by max price?
    if(this.max != -1 && variant.price > this.max) return false;

    //Either we're not filtering, or the product is within the price range!
    return true;
  }
});
AjaxCollectionPriceFilter.prototype.constructor = AjaxCollectionPriceFilter;

/*
 *  AjaxCollectionVendorFilter
 *    Filter for filtering down vendors in an ajax collection
 *
 *  Version:
 *    1.0.0 - 2018/10/16
 */
function AjaxCollectionVendorFilter(handle, collection, vendors) {
 AjaxCollectionFilter.call(this, handle, collection);

 //Params Default
 if(typeof vendors === typeof undefined) vendors = [];

 //Tag arrays
 this.vendors = vendors;
}

//Extend the base filter object.
AjaxCollectionVendorFilter.prototype = Object.assign(AjaxCollectionVendorFilter.prototype, AjaxCollectionFilter.prototype);
AjaxCollectionVendorFilter.prototype = Object.assign(AjaxCollectionVendorFilter.prototype, {
  addVendor: function(vendor) {
    if(this.vendors.indexOf(vendor) !== -1) return;
    this.vendors.push(vendor);
    this.collection.onFilterUpdate();
  },

  removeVendor: function(vendor) {
    var index = this.vendors.indexOf(vendor);
    if(index === -1) return;
    this.vendors.splice(index, 1);
    this.collection.onFilterUpdate();
  },

  //Get all settings, in this case we're returning an array of tags that this
  //filter is.. filtering by.
  getSettings: function() {
    return this.vendors;
  },

  //Get an individual setting (tag, either true or false if restricted)
  getSetting: function(vendor) {
    if(typeof vendor === typeof undefined) return this.vendors;
    return this.vendors.indexOf(vendor) !== -1;
  },

  //Set a setting, if true it will add that tag to this filter, if false it will
  //remove it.
  setSetting: function(key, value) {
    if(value) return this.addVendor(key);
    this.removeVendor(key);
  },

  //Set an array of tags (or pass a single tag) and it will force an update
  setSettings: function(settingSet) {
    if(!Array.isArray(settingSet)) settingSet = [ settingSet ];
    this.vendors = settingSet;
    this.collection.onFilterUpdate();
  },

  filter: function(product, variant) {
    //If we're not filtering by any tags, just return
    if(!this.vendors.length) return true;//No filtering

    //For each vendor in this filter...
    for(var i = 0; i < this.vendors.length; i++) {
      //Product has?
      var filterVendors = this.vendors[i];
      var hasThisVendor = product.vendor === filterVendors;

      if(hasThisVendor) {
        return true;
      }
    }

    //Remaining
    return false;
  }
});

/*
 *  AjaxCollectionSizeFilter
 *    Designed to take an array of sizes to filter the products by.
 */
function AjaxCollectionSizeFilter(handle, collection, operation, sizes) {
  AjaxCollectionFilter.call(this, handle, collection);

  if(typeof operation === typeof undefined || !operation) operation = "AND";
  if(typeof sizes === typeof undefined || !sizes) sizes = [];

  this.operation = operation;
  this.sizes = sizes;
}

AjaxCollectionSizeFilter.prototype = Object.assign(AjaxCollectionSizeFilter.prototype, AjaxCollectionFilter.prototype);
AjaxCollectionSizeFilter.prototype = Object.assign(AjaxCollectionSizeFilter.prototype, {
  addSize: function(size) {
    if(this.sizes.indexOf(size) !== -1) return;
    this.sizes.push(size);
    this.collection.onFilterUpdate();
  },

  removeSize: function(size) {
    var index = this.sizes.indexOf(size);
    if(index === -1) return;
    this.sizes.splice(index, 1);
    this.collection.onFilterUpdate();
  },

  getOperation: function() { return this.operation; },
  getSettings: function() { return this.sizes; },

  getSetting: function(size) {
    if(typeof size === typeof undefined) return this.sizes;
    return this.sizes.indexOf(size) !== -1;
  },

  setOperation: function(o) { this.operation = o;},

  setSetting: function(key, value) {
    if(value) return this.addSize(key);
    this.removeSize(key);
  },

  setSettings: function(settingSet) {
    if(!Array.isArray(settingSet)) settingSet = [ settingSet ];
    this.sizes = settingSet;
    this.collection.onFilterUpdate();
  },

  filter: function(product, variant) {
    if(!this.sizes.length) return true;

    //First find the option index
    var optionIndex = this.collection.getOptionIndex(product, ['Size']);
    if(optionIndex === -1) return false;

    var variantSize = variant.options[optionIndex].toLowerCase();
    for(var i = 0; i < this.sizes.length; i++) {
      var size = this.sizes[i].toLowerCase();
      if(this.operation == "OR" && size == variantSize) return true;
      if(this.operation == "AND" && size != variantSize) return false;
    }

    if(this.operation == "OR") return false;
    return true;
  }
});
AjaxCollectionSizeFilter.prototype.constructor = AjaxCollectionSizeFilter;


/*** Import Facets ***/
function AjaxCollectionFacet(collection, filter, container, title) {
  this.collection = collection;
  this.filter = filter;
  this.container = container;
  this.title = title;
}

AjaxCollectionFacet.prototype = {
  getCollection: function() {return this.collection;},
  getFilter: function() {return this.filter;},

  print: function() {
    var x = '';
    /*if(this.title) {
      x += '<span class="c-faceted-nav__title">';
      x += this.title.escapeHTML();
      x += '</span>';
    }*/
    x += this.getPrint();
    this.container.html(x);
  },

  getPrint: function() {
    return '';
  },

  //You may decide to sub this method
  onValuesUpdated: function() {
    this.print();
  },

  onProductsDrawn: function() {
    this.print();
  }
};

function AjaxCollectionCheckboxFacet(collection, filter, container, title, options) {
  AjaxCollectionFacet.call(this, collection, filter, container, title);
  if(typeof options === typeof undefined) options = [];
  this.options = options;//If undefined, null, or empty, it will use ALL Options

  //Listen for checkbox changes
  this.print();

  //Listen for checkbox changes
  this.container.on('change', '[data-facet-checkbox]', this.onChange.bind(this));
}

//Setup Super
AjaxCollectionCheckboxFacet.prototype = Object.assign(AjaxCollectionCheckboxFacet, AjaxCollectionFacet.prototype);
AjaxCollectionCheckboxFacet.prototype = Object.assign(AjaxCollectionCheckboxFacet.prototype, {
  getVisibleOptions: function() {
    return this.options;
  },

  print: function() {
    AjaxCollectionFacet.prototype.print.call(this);


    if(this.getVisibleOptions().length <= 1) {
      $('[data-collection-template-group]').addClass('is-hidden');
    } else {
      $('[data-collection-template-group]').addClass('is-visible');
    }
  },

  getPrint: function() {
    var options = this.getVisibleOptions();

    //Printing function
    var x = '<ul class="c-faceted-nav__check-group">';
    for(var i = 0; i < options.length; i++) {
      var option = options[i];
      x += '<li class="c-faceted-nav__check-item">';

      //Checkbox
      x += '<div class="o-checkbox">';

      x += '<input type="checkbox" class="c-faceted-nav__check o-checkbox__checkbox" ';
      x += 'data-index="'+i+'" ';
      x += 'data-option="'+option+'" ';
      if(this.isSelected(option)) x += 'checked ';
      x += 'data-facet-checkbox />';
      x += '<div class="o-checkbox__checkmark"></div>';
      x += '<label class="o-checkbox__label c-faceted-nav__label">'+this.getOptionName(option)+'</label>';
      x += '</div>';

      x += '</li>';
    }
    x += '</ul>';
    return x;
  },

  getOptionName: function(option) {
    return option.escapeHTML();
  },

  isChecked: function(option) {
    //Is Checked for checkboxes, not in sync with the filter
    var element = this.container.find('[data-facet-checkbox][data-option="'+option+'"]');
    if(!element.prop('checked')) return false;
    return true;
  },

  isSelected: function(option) {
    //Is selected, get value from filter
    //Uses lowercase too.
    return this.filter.getSetting(option);
  },

  getCheckedOptions: function() {
    //Get the options that are currently checked.
    var checked = [];
    for(var i = 0; i < this.options.length; i++) {
      if(!this.isChecked(this.options[i])) continue;
      checked.push(this.options[i]);
    }
    return checked;
  },

  onChange: function(e) {
    //Listen for change events and update the collection.
    var checkbox = $(e.target);
    var option = checkbox.attr('data-option');
    this.filter.setSetting(option, this.isChecked(option));
  },

  setOptions: function(options) {
    //Now set the options and force a redraw of myself.
    this.options = options;
    this.print();
  }
});

function AjaxCollectionColorSwatchFacet(collection, filter, container, title, options) {
  AjaxCollectionFacet.call(this, collection, filter, container, title);

  this.options = options;//If undefined, it will use ALL Colors as an option

  this.restrictByProducts = false;//If true will only show checks if the products have them.
  this.restrictByCollection = true;//If true will not show checks unless it's also in the collection

  this.container.on('click touchstart', '[data-swatch-filter]', this.onSwatchClick.bind(this));
  this.print();
}

AjaxCollectionColorSwatchFacet.prototype = Object.assign(AjaxCollectionColorSwatchFacet.prototype, AjaxCollectionFacet.prototype);
AjaxCollectionColorSwatchFacet.prototype = Object.assign(AjaxCollectionColorSwatchFacet.prototype, {
  getVisibleSwatches: function() {
    //This function can be used to determine what swatches to show and what
    //swatches to hide.
    var allOptions = this.options;
    if(typeof allOptions === typeof undefined) {
      allOptions = [];
      for(var i = 0; i < Swatches.length; i++) {
        allOptions.push(Swatches[i].name);
      }
    }

    //Fetch from the products in the collection
    var allCurrentColors = [];
    var allColors = [];
    if(
      (this.restrictByProducts || this.restrictByCollection) &&
      typeof this.collection.unpaginatedProducts !== typeof undefined
    ) {
      //typeof this.collection.unpaginatedProducts !== typeof undefined) {
      for(var i = 0; i < this.collection.variants.length; i++) {
        var v = this.collection.variants[i];
        var p = this.collection.productsById[v.product_id];

        //Skip Product
        if(!this.collection.isProductInCollection(p)) continue;

        //Find color option index
        var colorIndex = this.collection.getOptionIndex(p, ['Color', 'Colour']);
        if(colorIndex === -1) continue;

        var color = v.options[colorIndex].handleize();
        var swatch = null;
        //Fetch the swatch object that this color belongs to
        for(var x = 0; x < window.Swatches.length; x++) {
          var s = window.Swatches[x];
          if(s.handles.indexOf(color) === -1) continue;//Case sensitive
          swatch = s;
          break;
        }
        if(!swatch || typeof swatch.name !== "string") {
          swatch = color;
        } else {
          swatch = swatch.name;
        }

        if(allColors.indexOf(swatch) !== -1) continue;
        allColors.push(swatch);
        if(this.collection.unpaginatedProducts.indexOf(v) ===  -1) continue;
        allCurrentColors.push(swatch);
      }
    }

    var options = [];
    for(var i = 0; i < allOptions.length; i++) {
      var o = allOptions[i];

      if(this.isSelected(o)) {
        options.push(o);
        continue;
      }

      if(this.restrictByCollection && allColors.indexOf(o) === -1) continue;
      if(this.restrictByProducts && allCurrentColors.indexOf(o) === -1) continue;
      options.push(o);
    }

    return options;
  },

  getPrint: function() {
    var options = this.getVisibleSwatches();

    var x = '<div class="c-faceted-nav__swatch-group o-swatch__container">';
    for(var i = 0; i < options.length; i++) {
      var o = options[i];
      x += '<button type="button" class="o-swatch ';
      if(this.isSelected(o)) x += 'is-selected';
      x += '" data-swatch-filter data-swatch-value="' + o + '" '
      x += 'title="'+o+'" data-swatch-index="'+i+'"';
      x += '>';

      x += '<div class="o-swatch__inner o-swatch--color__inner s-swatch--'+o.handleize()+'">';
      x += '<span class="o-swatch__label">' + o.escapeHTML() + '</span>';
      x += '</div>';
      x += '</button>';
    }
    x += '</div>';
    return x;
  },

  isSelected: function(option) {
    return this.filter.getSetting(option);
  },

  onSwatchClick: function(e) {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    var self = $(e.currentTarget);
    var color = self.attr('data-swatch-value');
    if(self.hasClass('is-selected')) {
      this.filter.setSetting(color, false);
    } else {
      this.filter.setSetting(color, true);
    }
  },

  setOptions: function(options) {
    //Simply set the options
    this.options = options;
    this.print();
  }
});

/*
 *  AjaxCollectionPriceRangeFacet
 *    Facet to control a price filter based on a price range selector
 *
 *  Version:
 *    1.0.0 - 2018/10/11
 */
function AjaxCollectionPriceRangeFacet(collection, filter, container, title) {
  AjaxCollectionFacet.call(this, collection, filter, container, title);

  //Range
  this.range = { min: 0, max: 0 };

  //Force a print
  this.print();
}

AjaxCollectionPriceRangeFacet.prototype = Object.assign(AjaxCollectionPriceRangeFacet.prototype, AjaxCollectionFacet.prototype);
AjaxCollectionPriceRangeFacet.prototype = Object.assign(AjaxCollectionPriceRangeFacet.prototype, {
  onValuesUpdated: function() {
    //Recalculate the min and max range
    this.range.max = 0;
    for(var i = 0; i < this.collection.products.length; i++) {
      var p = this.collection.products[i];
      if(!this.collection.isProductInCollection(p)) continue;

      //Now iterate over the variants...
      for(var y = 0; y < p.variants.length; y++) {
        var v = p.variants[y];

        //This product is in this collection, use it's values;
        this.range.max = Math.max(this.range.max, v.price);
      }
    }

    //Now make sure the filter is aware of the new max
    if(this.filter.max > this.range.max) this.filter.max = -1;

    this.print();
    this.redrawSlider();
  },

  //Functions
  getPrint: function() {
    var min;
    var max;

    var min = Currency.formatMoney(Math.max(this.filter.min, 0));
    var max = Currency.formatMoney(this.filter.max);
    if(this.filter.max < 0) max = 'MAX';

    var x = '<div data-slider-range></div>';
    x += '<form>';
    x += '<input type="hidden" name="min-value" value="">';
    x += '<input type="hidden" name="max-value" value="">';
    x += '</form>';
    x += '<div class="noUi-results">';
    x += min + ' &nbsp; - &nbsp; ' + max;
    x += '</div>';
    return x;
  },

  onPrint: function() {
    this.redrawSlider();
  },

  redrawSlider: function() {
    var el = this.container.find('[data-slider-range]');
    if(!el.length) return;

    if(typeof this.rangeSlider !== typeof undefined) {
      this.rangeSlider.destroy();
    }

    this.rangeElement  = el[0];

    this.rangeSlider = noUiSlider.create(this.rangeElement, {
      start: [
        this.filter.min < 0 ? 0 : this.filter.min,
        this.filter.max < 0 ? this.range.max : this.filter.max
      ],
      step: 1,
      range: {
        'min': [this.range.min],
        'max': [this.range.max]
      },
      connect: true
    });
    this.rangeElement.noUiSlider.on('change', this.onSliderUpdate.bind(this));
  },

  onSliderUpdate: function(e, a, values, c) {
    var newMin = values[0];
    var newMax = values[1];
    this.filter.setSettings({min: newMin, max: newMax});
    this.collection.onFilterUpdate();
  }
});
AjaxCollectionPriceRangeFacet.prototype.constructor = AjaxCollectionPriceRangeFacet;


function AjaxCollectionTagFacet(collection, filter, container, title, options) {

  AjaxCollectionCheckboxFacet.call(this, collection, filter, container, title);



  this.options = options;

  this.restrictByProducts = false;//If true will only show checks if the products have them.

  this.restrictByCollection = true;//If true will not show checks unless it's also in the collection

}



//Setup Super

AjaxCollectionTagFacet.prototype = Object.assign(AjaxCollectionTagFacet, AjaxCollectionCheckboxFacet.prototype);

AjaxCollectionTagFacet.prototype = Object.assign(AjaxCollectionTagFacet.prototype, {

  getVisibleOptions: function() {

    //Returns a list of options based on the existing filters.

    var allOptions = this.options;



    var collectionTags = [];

    var productTags = [];



    //Convert Collection Tags to lowercase

    for(var i = 0; i < this.collection.allTags.length; i++) {

      var tLower = this.collection.allTags[i].toLowerCase();

      collectionTags.push(tLower);

    }



    //If there are no options set, use the collections tags as the options

    if(typeof allOptions === typeof undefined) {

      allOptions = this.collection.allTags;

    }



    //For each product currently unpaginated-ly printed, add their tags (no doubles)

    if(this.restrictByProducts && typeof this.collection.unpaginatedProducts !== typeof undefined) {

      for(var i = 0; i < this.collection.unpaginatedProducts.length; i++) {

        var v= this.collection.unpaginatedProducts[i];

        var p = v.product;



        for(var x = 0; x < p.tags.length; x++) {

          //Tags are converted to lowercase!!!

          var tLower = p.tags[x].toLowerCase();

          if(productTags.indexOf(tLower) !== -1) continue;

          productTags.push(tLower);

        }

      }

    }



    //Now generate the options

    var options = [];

    for(var i = 0; i < allOptions.length; i++) {

      //We need both the Option, as well as its tag (lowercase)

      var og = allOptions[i]

      var o = og.toLowerCase();// Tags are always converterd to lowercase



      //Always show checked filters, so that they may be unchecked

      if(this.isSelected(og)) {

        options.push(og);//Remember to append the OG for correct captilization

        continue;

      }



      //Check products (using lowercase tags)

      if(this.restrictByCollection && collectionTags.indexOf(o) === -1) continue;

      if(this.restrictByProducts && productTags.indexOf(o) === -1) continue;



      //Again, make sure we append the OG tag

      options.push(og);

    }

    return options;

  }

});

AjaxCollectionTagFacet.prototype.constructor = AjaxCollectionTagFacet;


function AjaxCollectionVendorFacet(collection, filter, container, title, options) {
  AjaxCollectionCheckboxFacet.call(this, collection, filter, container, title);

  this.options = options;
  this.restrictByProducts = false;//If true will only show checks if the products have them.
  this.restrictByCollection = true;//If true will not show checks unless it's also in the collection
}

//Setup Super
AjaxCollectionVendorFacet.prototype = Object.assign(AjaxCollectionVendorFacet, AjaxCollectionCheckboxFacet.prototype);
AjaxCollectionVendorFacet.prototype = Object.assign(AjaxCollectionVendorFacet.prototype, {
  getVisibleOptions: function() {
    var allOptions = this.options;

    var collectionVendors = [];
    var productVendors = [];

    for(var i = 0; i < this.collection.products.length; i++) {
      var p = this.collection.products[i];
      //In Collection?
      if(!this.collection.isProductInCollection(p)) continue;

      var vendor = p.vendor;
      if(collectionVendors.indexOf(vendor) !== -1) continue;
      collectionVendors.push(vendor);
    }

    if(this.restrictByProducts && typeof this.collection.unpaginatedProducts !== typeof undefined) {
      for(var i = 0; i < this.collection.unpaginatedProducts.length; i++) {
        var v= this.collection.unpaginatedProducts[i];
        var p = v.product;
        var vendor = p.vendor;
        if(productVendors.indexOf(vendor) !== -1) continue;
        productVendors.push(vendor);
      }
    }

    //If there are no options set, use the collections vendors as the options
    if(typeof allOptions === typeof undefined || !allOptions.length) {
      allOptions = collectionVendors;
    }

    //Now generate the options
    var options = [];
    for(var i = 0; i < allOptions.length; i++) {
      //We need both the Option, as well as its tag (lowercase)
      var o = allOptions[i]

      //Always show checked filters, so that they may be unchecked
      if(this.isSelected(o)) {
        options.push(o);//Remember to append the OG for correct captilization
        continue;
      }

      //Check products (using lowercase tags)
      if(this.restrictByCollection && collectionVendors.indexOf(o) === -1) continue;
      if(this.restrictByProducts && productVendors.indexOf(o) === -1) continue;

      //Again, make sure we append the OG tag
      options.push(o);
    }
    return options;
  }
});
AjaxCollectionVendorFacet.prototype.constructor = AjaxCollectionVendorFacet;


function AjaxCollectionSmartTagFacet(collection, filter, container, prefix, title) {

  AjaxCollectionTagFacet.call(this, collection, filter, container, title);



  this.prefix = prefix;

  this.updateTags();

}





AjaxCollectionSmartTagFacet.prototype = Object.assign(AjaxCollectionSmartTagFacet.prototype, AjaxCollectionTagFacet.prototype);

AjaxCollectionSmartTagFacet.prototype = Object.assign(AjaxCollectionSmartTagFacet.prototype, {

  onValuesUpdated: function() {

    this.updateTags();

  },



  updateTags: function() {

    var smartTags = [];

    for(var i = 0; i < this.collection.allTags.length; i++) {

      var t = this.collection.allTags[i];

      var tSplit = t.split('_');

      if(tSplit[0].toLowerCase() != this.prefix.toLowerCase()) continue;

      smartTags.push(t);

    }

    this.setOptions(smartTags);

  },



  getOptionName: function(tag) {

    //Now we can change the display of the tag to suit this collection

    var t = tag.split('_');

    t.shift();

    return t.join('_').escapeHTML();

  }

});

AjaxCollectionSmartTagFacet.prototype.constructor = AjaxCollectionSmartTagFacet;



/*** Import Sort ***/
/*
 *  AjaxCollection Sorting Functions
 */
var AjaxCollectionSort = {}
AjaxCollectionSort.getSorterByHandle = function(handle) {
  var keys = Object.keys(AjaxCollectionSort);

  for(var i = 0; i < keys.length; i++) {
    var s = AjaxCollectionSort[keys[i]];

    if(typeof s === typeof undefined) continue;
    if(typeof s.handle === typeof undefined) continue;
    if(typeof s.sort === typeof undefined) continue;
    if(s.handle.toLowerCase() != handle.toLowerCase()) continue;

    return s;
  }

  return null;
}



//Default
AjaxCollectionSort.default = {
  handle: "manual",
  name: "Featured",
  default: true,
  visible: function(collection) {
    if(collection.defaultSortBy == 'best-selling') return false;
    return true;
  },
  sort: function(collection, variantData) {
    return variantData.sort(function(l, r) {
      var handleL = AjaxCollectionSort.default.getPositionByHandle(collection, l.product.handle);
      var handleR = AjaxCollectionSort.default.getPositionByHandle(collection, r.product.handle);

      if(l.product.id == r.product.id) {
        //Determine order based on variant position
        var indexLeft = -1;
        var indexRight = -1;
        for(var i = 0; i < l.product.variants.length; i++) {
          var variant = l.product.variants[i];
          if(variant.id == l.id) indexLeft = i;
          if(variant.id == r.id) indexRight = i;
          if(indexLeft != -1 && indexRight != -1) break;
        }
        return indexLeft - indexRight;
      }

      return handleL - handleR;
    });
  },
  getPositionByHandle: function(collection, handle) {
    var index = collection.products.length;
    for(var i = 0; i < collection.productHandles.length; i++) {
      if(collection.productHandles[i] != handle) continue;
      index = i;
      break;
    }
    return index;
  }
};

AjaxCollectionSort.bestSelling = {
  handle: "best-selling",
  name: "Featured",
  visible: function(collection) {
    return !AjaxCollectionSort.default.visible(collection);
  },
  sort: AjaxCollectionSort.default.sort
};

//By Title
AjaxCollectionSort.nameAscending = {
  handle: "title-ascending",
  name: "A-z",
  hide: true,
  sort: function(collection, variantData) {
    return variantData.sort(function(l, r) {
      var titleL = l.product.title;
      var titleR = r.product.title;


      return titleL.localeCompare(titleR);
    });
  }
};
AjaxCollectionSort.nameDescending = Object.assign(Object.assign({}, AjaxCollectionSort.nameAscending), {
  handle: "title-descending",
  name: "Z-a",
  reverse: true,
  hide: true
});

//By Price
AjaxCollectionSort.priceAscending = {
  handle: "price-ascending",
  name: "Price, Low to High",
  sort: function(collection, variantData) {
    return variantData.sort(function(l,r) {
      return l.price - r.price;
    });
  }
};
AjaxCollectionSort.priceDescending = Object.assign(Object.assign({}, AjaxCollectionSort.priceAscending), {
  handle: "price-descending",
  name: "Price, High to Low",
  reverse: true
});

//By Date
AjaxCollectionSort.dateAscending = {
  handle: 'date-ascending',
  name: 'Date, Oldest First',
  hide: true,
  sort: function(collection, variantData) {
    return variantData.sort(function(l,r) {
      var dateL = new Date(l.product.published_at);
      var dateR = new Date(r.product.published_at);
      return dateL - dateR;
    });
  }
}
AjaxCollectionSort.dateDescending = {
  handle: 'date-descending',
  name: 'New',
  hide: true,
  sort: AjaxCollectionSort.dateAscending.sort,
  reverse: true
}

//By Color
AjaxCollectionSort.colorAscending = {
  handle: "color-ascending",
  name: "Color, A-z",
  hide: true,
  sort: function(collection, variantData) {
    return variantData.sort(function(l, r) {
      var colorL = AjaxCollectionSort.colorAscending.getColor(collection, l);
      var colorR = AjaxCollectionSort.colorAscending.getColor(collection, r);

      return colorL.localeCompare(colorR);
    });
  },

  getColor: function(collection, variant) {
    var colorIndex = collection.getOptionIndex(variant.product, ['Color', 'Colour']);
    if(colorIndex === -1) return "";//No Color

    //Check variant color exists
    return variant.options[colorIndex]
  }
};
AjaxCollectionSort.colorDescending = Object.assign(Object.assign({}, AjaxCollectionSort.colorAscending), {
  handle: "color-descending",
  name: "Color, Z-a",
  reverse: true,
  hide: true
});


/*** Import Pagination ***/
/*
 *  AjaxCollectionPaginator
 *    Provides base pagination controls for pagination methods.
 *
 *
 *  Version:
 *    1.0.0 - 2018/10/10
 */
function AjaxCollectionPaginator(collection, container) {
  this.container = container;
  this.collection = collection;
}

Object.assign(AjaxCollectionPaginator.prototype, {
  getPerPage: function() {
    return this.collection.perPage || 20;
  },

  getCurrentPage: function() {
    return this.collection.settings.page || 1;
  },

  getTotalPages: function() {
    //Returns the total pages based off the product count
    if(typeof this.collection.unpaginatedProductCount === typeof undefined) return 0;
    var count = this.collection.unpaginatedProductCount;//Count of total products (after filtering,but before paginating)
    return Math.ceil(count / this.getPerPage());
  },

  setPage: function(page) {
    this.collection.settings.page = Math.min(this.getTotalPages(), Math.max(page, 1));
    this.collection.onFilterUpdate();
    this.collection.draw();//For faster feedback we're going to FORCE a redraw.

    if(typeof this.onPageChange === "function") this.onPageChange(page);
  },

  paginate: function(variants) {
    //Standard paginate function, you can go more complex if you really want...
    //Get PerPage and Page values
    var perPage = this.getPerPage();
    var page = this.getCurrentPage();

    //Determine the start and and indexes, remember to not overflow array.
    var start = (page - 1) * perPage;
    var end = Math.min(variants.length, start+perPage);

    //Now generate the new array.
    var paginated = [];
    for(var i = start; i < end; i++) {
      paginated.push(variants[i]);
    }

    //Finally return the paginated products
    return paginated;
  },

  cancelClickEvent: function(e) {
    //Simple method that cancels event propogation
    if(typeof e === typeof undefined) return;
    if(typeof e.preventDefault !== typeof undefined) e.preventDefault();
    if(typeof e.stopPropagation !== typeof undefined) e.stopPropagation();
  },
});

/*
 *  AjaxCollectionPagination
 *    Standard page number pagination
 *
 *  Version:
 *    1.0.0 - 2018/10/03
 */
function AjaxCollectionPagination(collection, container) {
  AjaxCollectionPaginator.call(this, collection, container);

  //Standard Shopify Pagination controls
  this.container.on('click touchstart', '.prev', this.onPrev.bind(this));
  this.container.on('click touchstart', '.next', this.onNext.bind(this));
  this.container.on('click touchstart', '.page', this.onPageClick.bind(this));
}

Object.assign(AjaxCollectionPagination.prototype, AjaxCollectionPaginator.prototype);
Object.assign(AjaxCollectionPagination.prototype, {
  onPageChange: function(page) {
    $('html, body').animate({
      scrollTop: this.collection.productContainer.offset().top
    }, 400);
  },

  cancelClickEvent: function(e) {
    //Simple method that cancels event propogation
    if(typeof e === typeof undefined) return;
    if(typeof e.preventDefault !== typeof undefined) e.preventDefault();
    if(typeof e.stopPropagation !== typeof undefined) e.stopPropagation();
  },

  onUpdate: function() {
    //Called anytime the filters are updated, products are loaded, pages are changed etc.
    var x = '';
    var page = this.getCurrentPage();//Short hand

    //Prev Button
    if(this.getCurrentPage() > 1) {
      var url = this.collection.getFilteredUrl({
        page: (page - 1)
      });

      x += ' <span class="prev">';
      x += '<a href="'+url+'" title="">« Previous</a>';
      x += '</span> ';
    }

    //First, let's generate an array of numbers we want to draw (we always draw 1 and totalPages())
    var numbers = [];
    if(this.getTotalPages() > 1) {
      numbers = [1, this.getTotalPages()];
    }

    //Now add numbers page-2,page-1,page,page+1,page+2
    for(var i = page-2; i <= page+2; i++) {
      if(numbers.indexOf(i) !== -1) continue;//Already in the list
      if(i < 1) continue;
      if(i > page && i > this.getTotalPages()) continue;
      numbers.push(i);
    }
    numbers = numbers.sort();

    //Now we have a list of numbers, we can try and find gaps
    for(var i = 0; i < numbers.length; i++) {
      var n = numbers[i];
      if(n == 0) continue;
      var current = n == page;
      x += ' <span class="page ' + (current ? 'current': '') + '">';
      if(!current) {
        var url = this.collection.getFilteredUrl({
          page: n
        });
        x += '<a href="'+url+'" title="">';
      }
      x += n
      if(!current) x += '</a>';
      x += '</span> ';

      //Is there a gap?
      var nextExpected = n + 1;
      if(typeof numbers[i+1] !== typeof undefined && numbers[i+1] != nextExpected) {
        x += ' <span class="deco">…</span> ';
      }
    }

    //Next Button
    if(this.getCurrentPage() < this.getTotalPages()) {
      var url = this.collection.getFilteredUrl({
        page: (this.getCurrentPage() + 1)
      });

      x += ' <span class="next">';
      x += '<a href="'+url+'" title="">Next »</a>';
      x += '</span> ';
    }

    this.container.html(x);
  },

  //Pagination button functions
  onPrev: function(e) {
    this.cancelClickEvent(e);
    this.setPage(this.getCurrentPage() - 1);
  },

  onNext: function(e) {
    this.cancelClickEvent(e);
    this.setPage(this.getCurrentPage() + 1);
  },

  onPageClick: function(e) {
    this.cancelClickEvent(e);

    var self = $(e.currentTarget);
    if(self.hasClass('current')) return;

    var page = parseInt(self.text());
    this.setPage(page);
  }
});
AjaxCollectionPagination.prototype.constructor = AjaxCollectionPagination;

/*
 *  AjaxCollectionPagination
 *    Provides the basis for the pagination for a given AjaxCollection.
 *
 *  Version:
 *    1.0.0 - 2018/10/03
 */
function AjaxCollectionLoadMore(collection, container) {
  AjaxCollectionPaginator.call(this, collection, container);

  //Looking for the standard load more button here
  this.loadMoreButton = this.container.find('[data-load-more]');
  this.container.on('click', '[data-load-more]', this.onLoadMore.bind(this));
}

Object.assign(AjaxCollectionLoadMore.prototype, AjaxCollectionPaginator.prototype);
Object.assign(AjaxCollectionLoadMore.prototype, {
  onLoadMore: function(e) {
    this.cancelClickEvent(e);
    this.setPage(this.getCurrentPage() + 1);
  },

  paginate: function(variants) {
    //Get values...
    var perPage = this.getPerPage();
    var page = this.getCurrentPage();

    //Determine the start and and indexes, remember to not overflow array.
    var start = 0;
    var end = Math.min(variants.length, start+(perPage*page));

    //Now generate the new array.
    var paginated = [];
    for(var i = start; i < end; i++) {
      paginated.push(variants[i]);
    }

    //Finally return the paginated products
    return paginated;
  },

  onUpdate: function() {
    if(this.getCurrentPage() >= this.getTotalPages()) {
      this.loadMoreButton.addClass('is-hidden');
    } else {
      this.loadMoreButton.removeClass('is-hidden');
    }
  }
});
AjaxCollectionLoadMore.prototype.constructor = AjaxCollectionLoadMore;







/*
 *  AjaxCollection
 *    Asyncrhonous Javascript Collection code for fetching products on the fly.
 *
 *  Version:
 *    2.3.0 - 2018/10/16
 */

//CONSTANTS
var PRODUCT_CACHE_DATE_KEY = "AjaxCollectionProductCacheTime";
var PRODUCT_CACHE_DATA_KEY = "AjaxCollectionProductCacheData";

//Constructor
function AjaxCollection(container) {
  /*** SETUP CONTAINERS ***/
  //You should super this class with your own collection javascript wrapper.
  this.container = container;
  this.productContainer = container.find('[data-collection-template-products]');//The place the products will get printed.
  this.handle = this.container.attr('data-collection-handle') || null;



  /*** SETUP DEFAULTS ***/
  //Attempt to detect the per-page-ness
  this.perPage = parseInt(container.attr('data-collection-per-page')) || 1;//Failsafe...

  //Arrays (Contains the direct list in no particular order)
  this.variants = [];
  this.products = [];
  this.filters = [];//Contains the filter components
  this.facets = [];//Contains the facet components

  //Objects, contains the list mapped by ids
  this.variantsById = {};
  this.productsById = {};
  this.pageData = {};

  //Clean existing, since our JS is way smarter than the Liquid
  //this.productContainer.html('');



  /*** FETCH QUERY RELATED DATA ***/
  //Fetch Query Settings
  this.settings = this.getFilterSettingsFromUrl(window.location.search);

  //Current page, fetched from the query object
  this.initialPage = parseInt(this.settings.page) ? parseInt(this.settings.page) : 1;//Defaults to page 1.



  /*** SETUP SORTING ***/
  //Sorting?
  this.sorting = AjaxCollectionSort.default;//Here you can setup your default
  this.defaultSortBy = "";
  //The default sort will be read out of the collection data, and then overriden by
  //the loaded query string params


  /*** SETUP PAGINATION ***/
  //You will need to set your own pagination onto this.pagination


  /*** READ PRODUCT CACHES ***/
  //Read in data from local storage.
  var cachedData = this.readProductCache();
  this.addProducts(cachedData);
  //Note, we don't fire an update event, since this cached data may be old, and
  //subclass methods may also need more collection information (not cached), so
  //wait until it's read next before firing the event.

  //Now we're going to try and find if there's any existing product JSON on the page to use.
  this.jsonContainer = container.find('[data-collection-json]');
  if(this.jsonContainer.length) {
    //Cool, there's some JSON on the page, let's try and read it in.
    var raw = this.jsonContainer.html();
    try {
      var json = JSON.parse(raw);
      this.readProductData(json);//Attempt a read
    } catch(e) {
      console.error("Failed to read existing product JSON (Ensure it's correct)");
      console.error(e);
    }
  }

  //Product handles (for both ordering and determining what we can print)
  //2018-10-03 - NOTE I found an issue related to the way that this was working,
  //particularly with pagination... Since setting ?page=2 would cause no products
  //to print, or print invalid data. The solution is to use Ajax and fetch page 1
  //every time (unless you're already on page 1)
  this.handlesJsonContainer = container.find('[data-collection-product-handles]');
  if(!this.handlesJsonContainer.length) {
    console.error("Warning, the collection handles snippet was not found! Ignore this error if you're on page 1.");
  } else {
    var raw = this.handlesJsonContainer.html();
    try {
      var json = JSON.parse(raw);
      this.productHandles = json;
    } catch(e) {
      console.error("Error parsing the JSON Handles");
      console.error(e);
    }
  }



  //Now check to see if that loaded our default sort method
  if(this.defaultSortBy && this.defaultSortBy.length) {
    //We have a default sort from the collection data that was loaded.
    var sorter = AjaxCollectionSort.getSorterByHandle(this.defaultSortBy);
    if(sorter !== null) this.sorting = sorter;
  }

  //Read in sort_by from query string.
  if(typeof this.settings['sort_by'] === "string") {
    var sorter = AjaxCollectionSort.getSorterByHandle(this.settings.sort_by);
    if(sorter !== null) this.sorting = sorter;
  }



  //Now we can fire the event if there was some cache data!
  if(cachedData && cachedData.length) {
    this.onProductsUpdated();
  }

  /*
    At this point your subclass can do what it pleases, but to start, however
    your subclass needs to call this.start and this.draw before AjaxCollection
    will appear to work!!!!!!
  */
}




AjaxCollection.prototype = {
  //Fetching
  getQueryData: function(page) {
    //Returns the query parameters that will get passed to the fetch url.
    var data = {
      view: 'json',
      page: page
    };
    return data;
  },

  getQueryURL: function() {
    //Returns the url that is being queried.
    return '/collections/'+this.handle;
  },

  fetch: function(page) {
    //Double check we aren't done.
    if(page !== 1 && !this.isRunning()) return;//Done? maybe there's an async issue, exit.

    //Page is optional, it can be a forced value, or determined by where we
    //may expect to find products we don't already have.
    if(typeof page === typeof undefined) {
      //We're going to determine the next page.

      //Initial page maybe?
      if(typeof this.pageData[""+this.initialPage] === typeof undefined) {
        return this.fetch(this.initialPage);
      }

      //Since the cache is likely to contain products from the current page, plus
      //all the products that had been fetched up to a point, it will likely be
      //already up to the page that we need... we can test there for starters.
      var expectedPage = Math.ceil((this.products.length+1) / this.perPage);
      //Have we fetched the expected page yet?
      if(typeof this.pageData[""+expectedPage] === typeof undefined) {
        //No, we haven't, let's fetch the expected page.
        return this.fetch(expectedPage);
      }

      //Ok, we have already fetched the expected page... We're going to fill in
      //the holes in our product data. Let's do this in page order since likely
      //we want the first pages to begin with.
      var fetchPage = 1;//Start with 1
      while(true) {
        if(typeof this.pageData[""+fetchPage] === typeof undefined) break;//We haven't fetched, exit!
        if(!this.pageData[""+fetchPage].products.length) break;//No Products on this page?
        fetchPage++;//We have fetched.. try the next page

        //Okay small note here, there is potential for an issue here, this fetchPage
        //value will forever get larger until either A, all the products are successfully fetched,
        //or B the script crashes or something...

        //I do think I need a better way of being CERTAIN that all products up
        //to this point have been fetched..
        //Quick ideas for the future:
        //  Check if there's duplicate products, if so then refetch early pages by force.
        //  Guess amount of products we should have based on page and perPage count, if getting out of hand, refetch by force.
      }

      if((fetchPage * this.perPage) >  this.productCount) {
        console.log("All data fetched 22?");
        return;
      }
      return this.fetch(fetchPage);
    }

    if(typeof this.pageData[""+page] !== typeof undefined) {
      console.log("All data fetched?");
      //return;
    }

    console.log("Fetching page " + page);

    var o = {
      url: this.getQueryURL(),
      method: 'GET',
      data: this.getQueryData(page),
      self: this,
      page: page
    };

    //Bind our custom callback.
    o.success = this.onSuccess.bind(o);
    o.error = this.onError.bind(o);
    o.request = $.ajax(o);
  },

  //For onSuccess and onError, these functions will be bound to have "this" be "this.self"..
  //Refer to fetch() for the bound object.
  onSuccess: function(data) {
    try {
      this.self.readProductData(JSON.parse(data));
    } catch(e) {
      this.error(e);//Not this.onError, again bound object callback.
    }

    if(this.self.isRunning()) this.self.fetch();
  },

  onError: function(e, i, d) {
    this.self.clearProductCache();//Integrity of cache is important

    if(e) console.log(e);
    if(i) console.log(i);
    if(d) console.log(d);
  },
  //End bound functions

  isRunning: function() {
    if(!this.hasStarted) return false;
    if(typeof this.productHandles === typeof undefined) return true;//We don't know how many products there are... keep fetching.
    for(var i = 0; i < this.productHandles.length; i++) {
      var handle = this.productHandles[i];
      var found = false;
      for(var x = 0; x < this.products.length; x++) {
        if(this.products[x].handle != handle) continue;
        found = true;
        break;
      }
      if(!found) return true;
    }
    return false;
  },

  start: function() {
    //We first need to hint at our filters that we're ready, they'll have to
    //load whatever predefined settings this collection has
    for(var i = 0; i < this.filters.length; i++) {
      var f = this.filters[i];
      var settingSet = null;//Prevent Hoisting
      if(typeof this.settings !== typeof undefined && typeof this.settings[f.handle] !== typeof undefined) {
        settingSet = this.settings[f.handle];
      }
      f.init(settingSet);
    }
    this.onFilterUpdate();

    this.hasStarted = true;
    this.fetch(1);//Due to an issue I found with pagination we HAVE to fetch page 1, ALWAYS
  },

  readProductData: function(data) {

    if(typeof data.products === typeof undefined) throw new Error("Invalid JSON (Missing Products)");
    if(typeof data.page === typeof undefined) throw new Error("Invalid JSON (Missing Product Data)");
    if(typeof data.all_tags === typeof undefined) throw new Error("Invalid JSON (Missing Collection Information)");
    if(typeof data.default_sort_by !== typeof undefined) {
      if(data.default_sort_by.length) this.defaultSortBy = data.default_sort_by;
    }

    //Add products (internally)
    this.addProducts(data.products);

    //To help fix an issue with pagination I was having, if the collection data
    //contains all the product handles for this collection, merge them.
    if(typeof data.all_product_handles !== typeof undefined) {
      this.productHandles = data.all_product_handles;
      this.hasFetchedAllHandles = true;//Just for making reasons, I wouldn't rely on this variable...
    }

    //Map data to page
    this.pageData[""+data.page] = data;

    //Update collection values
    this.allTags = data.all_tags || this.allTags || [];
    this.productCount = data.all_products_count || undefined;

    //Update the cache data
    this.writeProductCache();

    //Update our filters, facets, sorters, and pagination
    this.onFilterUpdate();

    //Product data has been mapped.
    this.onProductsUpdated();
    this.queueDraw();
  },

  addProducts: function(productArray) {
    //Adds the productArray of products to the data. No fancy updating of cache
    //or firing of events, raw adding to arrays and lists only.
    for(var i = 0; i < productArray.length; i++) {
      var p = productArray[i];
      this.addProduct(p);
    }
  },

  addProduct: function(p) {
    var id = p.id;

    //Don't double up. Check if this product is already in the array
    if(typeof this.productsById[id] !== typeof undefined && this.productsById[id].id === p.id) {
      //Already in the array, let's use the added version, probably newer.
      this.removeProduct(this.productsById[id]);
    }

    //Add to array, and map.
    this.products.push(p);
    this.productsById[p.id] = p;

    //Add child variants
    for(var x = 0; x < p.variants.length; x++) {
      var v = p.variants[x];
      this.addVariant(v);
    }
  },

  addVariant: function(v) {
    var id = v.id;

    //Same with products, don't double up on variants, remove the old version to
    //make way for this variant.
    if(typeof this.variantsById[id] !== typeof undefined && this.variantsById[id].id === v.id) {
      //Already in the array, let's use the added version, probably newer.
      this.removeVariant(this.variantsById[id]);
    }

    this.variants.push(v);
    this.variantsById[v.id] = v;
  },

  removeProduct: function(p) {
    var oldIndex = this.products.indexOf(p);
    if(oldIndex !== -1) this.products.splice(oldIndex, 1);
    for(var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      this.removeVariant(v);
    }
  },

  removeVariant: function(v) {
    var oldIndex = this.variants.indexOf(v);
    if(oldIndex !== -1) this.variants.splice(oldIndex, 1);
    delete this.variantsById[v.id];
  },

  /*
   *  Everything above this line is related to FETCHING the product information
   *  =========================================================================
   *  Everything below this line is related to PRINTING the product information
   */
  getVariantURL: function(variant) {
    var p = variant.product;
    var url = '/collections/'+this.handle+'/products/'+p.handle;
    if(p.variants.length) url += '?variant=' + variant.id;
    return url;
  },

  getOptionIndex: function(product, titles) {
    if(!Array.isArray(titles)) titles = [ titles ];

    for(var i = 0; i < product.options.length; i++) {
      var o = product.options[i].toLowerCase();

      for(var j = 0; j < titles.length; j++) {
        if(o != titles[j].toLowerCase()) continue;
        return i;
      }
    }

    return -1;
  },

  isVariantOnSale: function(variant) {
    if(variant.compare_at_price == null) return false;
    return variant.compare_at_price > 0 && variant.price < variant.compare_at_price;
  },

  isVariantAvailable: function(variant) {
    if(!variant) return false;
    if(typeof variant === typeof undefined) return false;
    return variant.available;
  },

  getVariantsToDrawForProduct: function(product, modeOverride) {
    //Returns an array of variants to draw for a given product.
    //Use either all variants, only one variant (related to most relevant?)
    //or specific subset of variants (say.. colour?)

    //I've provided a few common examples here, you can chose to add your own
    var mode = modeOverride || this.displayMode || 'first-available-variant';
    var variants = [];

    //First available variant.
    if(mode == 'first-available-variant') {
      for(var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if(!this.isVariantAvailable(v)) continue;
        variants = [v];
        break;
      }
      if(!variants.length) variants = [product.variants[0]];
    }

    //First Variant
    if(mode == 'first-variant') {
      variants = [product.variants[0]];
    }

    //All Variants
    if(mode == 'all-variants') {
      variants = product.variants;
    }

    //Sale Variants
    if(
      mode == 'all-sale-variants' || mode == 'all-available-sale-variants'||
      mode == 'all-non-sale-variants' || mode == 'all-available-non-sale-variants'
    ) {
      for(var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        var onSale = this.isVariantOnSale(variant);
        if(mode.indexOf('available') !== -1 && !this.isVariantAvailable(variant)) continue;

        if(onSale && (mode == 'all-non-sale-variants' || mode == 'all-available-non-sale-variants')) continue;
        if(!onSale && (mode == 'all-sale-variants' || mode == 'all-available-sale-variants')) continue;
        variants.push(variant);
      }
    }

    //Colors
    if(
      mode == 'all-colors' || mode == 'all-sale-colors' || mode == 'all-non-sale-colors' ||
      mode == 'all-available-colors' || mode == 'all-available-sale-colors' || mode == 'all-available-non-sale-colors'
    ) {
      //Find the option that has color... (if any)
      var colorOptionIndex = this.getOptionIndex(product, ['Color', 'Colour']);

      //Does it have a color?
      if(colorOptionIndex === -1) {
        //OKAY so this particular product does NOT have a color option, we can
        //chose to do something custom if we like here.
        //at the moment I'm going to just display 1 of the variants
        variants = this.getVariantsToDrawForProduct(product, 'first-variant');
      } else {
        //The map of variants, by color, used to check what colors have been printed
        var variantsByColor = {};

        //Check the variants
        for(var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];

          //Available?
          if(mode.indexOf('available') !== -1 && !this.isVariantAvailable(v)) continue;

          //Sale params?
          if((mode == 'all-non-sale-colors' || mode == 'all-available-non-sale-colors') && this.isVariantOnSale(v)) continue;
          if((mode == 'all-sale-colors' || mode == 'all-available-sale-colors') && !this.isVariantOnSale(v)) continue;

          //Get the color
          var color = v.options[colorOptionIndex];//This is the color of the variant

          //Do we already have a product for this color? If so don't bother
          if(typeof variantsByColor[color] !== typeof undefiend && variantsByColor[color]) continue;

          //We don't have this color defined, before making this variant the
          //winner of this color, check to make sure it's not being filtered out.
          var keep = true;
          for(var j = 0; j < this.filters.length; j++) {
            if(this.filters[j].filter(product, v)) continue;
            keep = false;
            break;
          }
          if(!keep) continue;//Being filtered out..

          //Not being filtered out, this is going to become primary variant.
          variantsByColor[color] = v;
          variants.push(v);
        }
      }
    }

    return variants;
  },

  getVariantsToDraw: function() {
    //Return an array of variants to draw. You may opt to draw each kind
    //of variant, or may opt to draw only one kind (e.g. a product thumb)
    var draw = [];

    //Get all products...
    for(var i = 0; i < this.products.length; i++) {
      var p = this.products[i];

      //Is this product in this collection?
      if(!this.isProductInCollection(p)) continue;

      //Is this a hidden product?
      if(p.isHidden === true) continue;

      var variants = this.getVariantsToDrawForProduct(p);

      for(var x = 0; x < variants.length; x++) {
        var v = Object.assign({}, variants[x]);

        //Now, we can check our filters, this makes this technically an AND filter
        var filteredOut = false;
        for(var y = 0; y < this.filters.length; y++) {
          var filter = this.filters[y];
          filteredOut = !filter.filter(p, v);
          if(filteredOut) break;
        }
        if(filteredOut) continue;

        //Hack insert the product as a reference. Do this here so that we don't
        //generate a cycling error when caching the JSON for the variant!
        //(Also hence the clone)
        v.product = p;
        draw.push(v);
      }
    }


    //Now we can sort.
    var sorter = this.sorting;
    if(typeof sorter !== typeof undefined && sorter) {
      draw = sorter.sort(this, draw);

      if(typeof sorter.reverse !== typeof undefined && sorter.reverse === true) {
        draw.reverse();
      }
    }

    this.unpaginatedProducts = draw;
    this.unpaginatedProductCount = draw.length;//Pagination often needs this value.

    //Paginate?
    if(typeof this.pagination !== typeof undefined) {
      draw = this.pagination.paginate(draw);
    }

    return draw;
  },

  isPrinted: function(variantId) {
    //Simple check to see if a particular variant is already printed (or not)
    if(typeof variantId.id !== typeof undefined) {
      variantId = variantId.id;
    }

    var thumb = this.productContainer.find('[data-product-thumbnail][data-variant-id="'+variantId+'"]');
    if(!thumb.length) return null;
    return thumb;
  },

  isProductInCollection: function(product) {
    for(var x = 0; x < this.productHandles.length; x++) {
      if(product.handle != this.productHandles[x]) continue;
      return true;
    }
    return false;
  },

  queueDraw: function() {
    //Due to high document writes, reads, iteration etc, particularly on small devices
    //We have this nice render timeout to make sure that rendering happens when
    //needed (Every 500ms or so)
    if(typeof this.renderTimeout !== typeof undefined) return;
    this.renderTimeout = setTimeout(function() {
      this.draw();
    }.bind(this), 500);
  },

  draw: function() {
    //Clear render timeout function
    if(typeof this.renderTimeout !== typeof undefined) {
      clearTimeout(this.renderTimeout);
    }
    delete this.renderTimeout;

    //Get the array of array of variants to draw.
    var draw = this.getVariantsToDraw();

    //Clear thumbs that no longer need to be printed...
    var thumbs = this.container.find('[data-product-thumbnail]');
    var thumbArray = thumbs.toArray();

    for(var i = 0; i < thumbArray.length; i++) {
      var willBePrinted = false;//If true, stay printed, else remove
      var e = $(thumbArray[i]);//Element
      for(var x = 0; x < draw.length; x++) {
        var v = draw[x];
        if(v.id != e.attr('data-variant-id')) continue;
        willBePrinted = true;//Stay printed.
        break;
      }
      if(willBePrinted) continue;
      //Remove
      e.remove();
    }

    //Now we should only have the variants that are printed left
    var previous = null;//Used to track the "previously printed element"
    for(var i = 0; i < draw.length; i++) {
      var variant = draw[i];
      var element = this.isPrinted(variant);

      if(!element) {
        //Product is not printed... generate the HTML
        element = this.generatePrint(variant, i);
        if(previous) {
          previous = $(element).insertAfter(previous);
          continue;
        } else {
          //Is there any existing element?
          previous = this.productContainer.children().first();
          if(previous.length) {
            previous = $(element).insertBefore(previous);
            continue;
          }

          //Inject HTML and get element.
          this.productContainer.append(element);
          previous = $(this.productContainer.children().first());
          continue;
        }
      }

      //This is the first element, we have nothing to do!
      if(!previous) {
        previous = element;
        continue;
      }

      //Insert after previous element.
      element.insertAfter(previous);
      previous = element;
    }

    console.log("Drawing");
    this.drawnProducts = draw;

    //Update our facets
    this.onFilterUpdate(false);

    this.onProductsDrawn(draw);
  },

  //Events
  onProductsUpdated: function() { /* Called when product data has been added to the list */ },
  onProductsDrawn: function() { /* Called when products have been drawn */ },

  generatePrint: function(variant, index) {
    //Super simple, override this with your print.
    var x = '<div ';
    x += 'data-product-thumbnail ';
    x += 'data-product-handle="'+variant.product.handle+'" '
    x += 'data-product-id="'+variant.product.id+'" '
    x += 'data-variant-id="'+variant.id+'" '
    x += '>' + index + ' - ' + variant.product.title.escapeHTML() + ' / ' + variant.title.escapeHTML() + '</div>';
    return x;
  },


  /*
   *  Everything above this line is related to PRINTING the product information
   *  =========================================================================
   *  Everything below this line is related to CACHING the product information
   */
  readProductCache: function() {
    if(typeof localStorage === typeof undefined) return [];
    if(typeof localStorage.getItem === typeof undefined) return [];
    if(!localStorage.getItem(PRODUCT_CACHE_DATA_KEY)) return [];
    if(!localStorage.getItem(PRODUCT_CACHE_DATE_KEY)) return [];

    //First, how old is this data?
    if(!this.isCacheAlive()) return [];//Out of date.

    //Now, let's attempt a read
    try {
      var dataRaw = localStorage.getItem(PRODUCT_CACHE_DATA_KEY);
      var data = JSON.parse(dataRaw);

      if(!Array.isArray(data)) throw new Error("Invalid Product Data (Not an array)");

      //Good?
      return data;
    } catch(e) {
      console.error("Failed to read Product Data from cache.");
      console.error(e);
    }
    return [];//:(
  },

  isCacheAlive: function() {
    //Returns TRUE if the cache is still allowed to be use, false if it has
    //expired.
    if(typeof localStorage === typeof undefined) return false;
    if(typeof localStorage.getItem === typeof undefined) return false;
    if(!localStorage.getItem(PRODUCT_CACHE_DATA_KEY)) return false;
    if(!localStorage.getItem(PRODUCT_CACHE_DATE_KEY)) return false;

    //First, how old is this data?
    try {
      var cacheAge = new Date( JSON.parse(localStorage.getItem(PRODUCT_CACHE_DATE_KEY)) );
      var now = new Date();
      var diff = now - cacheAge;
      //Cache cannot be in the future
      if(diff < 0 || isNaN(diff) || !isFinite(diff)) throw new Error("Cache from the future?");
      if(diff > 1000*60*10) return false;//Cache expired (1000ms * 60s * 10mins)
      //Cache is good to use
    } catch(e) {
      console.error("Failed to read Product Data age.");
      console.error(e);
      return false;
    }
    return true;
  },

  writeProductCache: function() {
    if(typeof localStorage === typeof undefined) return;//Nothing to do?
    if(typeof localStorage.getItem === typeof undefined) return;
    if(typeof localStorage.setItem === typeof undefined) return;
    if(typeof this.canWriteProductCache !== typeof undefined && !this.canWriteProductCache) return;

    //Only update the time if it's non existant, or expired
    if(!localStorage.getItem(PRODUCT_CACHE_DATE_KEY)) {
      localStorage.setItem(PRODUCT_CACHE_DATE_KEY, JSON.stringify(new Date().getTime()) );//Set Cache Time
    } else if(!this.isCacheAlive()) {
      this.canWriteProductCache = false;//No Writing allowed
      //Clear the existing cache data
      this.clearProductCache();

      //Did the clear succeed?
      this.canWriteProductCache = (
        typeof localStorage.getItem(PRODUCT_CACHE_DATA_KEY) === typeof undefined ||
        localStorage.getItem(PRODUCT_CACHE_DATA_KEY) == null
      );
      return;
    }

    //Now we have our product data to be cached, let's attempt to store it
    try {
      localStorage.setItem(PRODUCT_CACHE_DATA_KEY, JSON.stringify(this.products));
    } catch(e) {
      console.error("Failed to update Product Data cache");
      console.error(e);
    }
  },

  clearProductCache: function() {
    try {
      localStorage.removeItem(PRODUCT_CACHE_DATE_KEY);
      localStorage.removeItem(PRODUCT_CACHE_DATA_KEY);
    } catch(e) {
      console.error("Failed to clear existing Product Data Cache");
      console.error(e);
    }
  },

  /*
   *  Everything above this line is related to CACHING the product information
   *  =========================================================================
   *  Everything below this line is related to FILTERING the product information
   */
  //Please note that actual filtering is part of the getVariantsToDrawForProduct function.
  addFilter: function(filter) {
    this.filters.push(filter);

    this.onFilterUpdate();
  },

  removeFilter: function(filter) {
    var index = this.filters.indexOf(filter);
    if(index === -1) return;
    this.filters.splice(index, 1);
    this.onFilterUpdate();
  },


  /*
    Here's my "Really quick" How the URLs work for both parsing and unparsing
    Example Query:
      ?size=20,30,50&color=Red&group=(range%253D0-100%2526vendor%253DApple)

    Bloated:
      {
        size: [ 20, 30, 50 ],
        color: [ "Red" ],
        group: {
          range: {min:0, max:100},
          vendor: "Apple"
        }
      }

    Just an example.
  */

  getFilteredUrl: function(overrides) {
    //Check overrides, custom overrides for the internal settings.
    if(typeof overrides === typeof undefined) overrides = {};

    //Returns the url for the page, based on current filter settings.
    var x = '/collections/' + this.handle;


    //Fallback Tag support, tag only the first tag from each filter and put them
    //into a nice + array, not exactly the same but very similar
    var tags = [];
    for(var i = 0; i < this.filters.length; i++) {
      var f = this.filters[i];
      if(!(f instanceof AjaxCollectionTagFilter)) continue;
      if(!f.tags.length) continue;

      //Check the operation type, if it's AND we may be able to do it the old
      //fashioned way.
      if(f.operation == "AND") {
        //Awesome, this is an AND Filter, we can be more specific
        tags.concat(f.tags);
      } else {
        tags.push(f.tags[0]);//Only going to use the first tag.
      }
    }
    var oldTags = tags;
    var tags = [];
    for(var i = 0; i < oldTags.length; i++) {
      var t = oldTags[i];
      if(tags.indexOf(t) !== -1) continue;
      tags.push(t);
    }
    if(tags.length) x += '/' + tags.join('+').toLowerCase();//Shopify convers the tags to lowercase


    //Query time
    var queryParams = this.getFilterSettings();
    var queryKeys = Object.keys(queryParams);

    //Add override keys
    var overrideKeys = Object.keys(overrides);
    for(var i = 0; i < overrideKeys.length; i++) {
      queryKeys.push(overrideKeys[i]);
    }

    if(!queryKeys.length) return x;

    //Create our escaping function...
    var escape = function(object) {
      var keys = Object.keys(object);
      var bufferArray = [];

      for(var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = object[key];
        var buffer;

        //Check overrides
        if(typeof overrides[key] !== typeof undefined) {
          value = overrides[key];
        }

        //If undefined just ignore.
        if(typeof value === typeof undefined) continue;

        //Change the format depending on the type
        if(Array.isArray(value)) {
          if(!value.length) continue;
          buffer = value.join(',');//Comma seperate Arrays

        } else if(typeof value === "object") {
          var subBuffer = escape(value);//Objects become wrapped subobjects
          if(!subBuffer.length) continue;
          buffer = "(" + subBuffer + ")";

        } else {
          buffer = "" + value;//Convert to string
          if(!buffer.length) continue;//Empty string.
        }

        //Append to array!
        bufferArray.push(encodeURIComponent(key) + '=' + encodeURIComponent(buffer));
      }

      //Join with ampersands (They'll be escaped if sub objecting)
      return bufferArray.join('&');
    };

    x += '?'+escape(queryParams);//Add our query escape

    return x;
  },

  getFilterSettings: function() {
    var o = {};

    //Get from filters
    for(var i = 0; i < this.filters.length; i++) {
      var f = this.filters[i];
      var settings = f.getSettings();

      //First see if there's anything worth storing... we don't want to store
      //default values
      if(Array.isArray(settings) && !settings.length) continue;//Nothing to store...

      o[f.handle] = settings;
    }

    //Get from page
    if(this.settings.page && this.settings.page > 1) {
      o['page'] = this.settings.page;
    }

    //Get from sorting
    if(typeof this.sorting !== typeof undefined && (
      typeof this.sorting.default === typeof undefined ||
      this.sorting.default === false
    )) {
      o['sort_by'] = this.sorting.handle;
    }

    return o;
  },

  getFilterSettingsFromUrl: function(url) {
    //Reverse of the above two functions.
    var params = url.split('?');//Extract the query string...
    if(params.length == 0) {
      return {};//None was passed? / Empty string
    } else if(params.length == 1) {
      //No URL, just a query string, don't need to do anything
    } else {
      var newParams = [];//Multiple Query strings, join them together and drop the URL
      for(var i = 1; i < params.length; i++) {
        newParams.push(params[i]);
      }
      params = newParams;
    }
    params = params.join('?');

    //Now we have the params string, let's create our unescaping function
    var unescape = function(string) {
      var o = {};//We're going to dump our data into this object
      var parts = string.split('&');
      //Now we have an array like ["page=2", "size=20,30,40", "group=(escaped..)"]
      for(var i = 0; i < parts.length; i++) {
        //Figure out the type!
        var spl = parts[i].split('=');//Should now be [key, value]
        if(spl.length != 2) continue;//?
        var key = spl[0];
        var val = decodeURIComponent(spl[1]);

        //Switch types
        if(val.startsWith("(")) {
          //Likely a nested object
          var val = val.substring(1, val.length-1);//Remove the brackets
          val = unescape(decodeURIComponent(val));//Unescape.
        } else {
          //Default (array)
          val = val.split(",");//Seperates into either ["10","20","30"] or ["String"]
          if(!val.length) continue;//Ignore empty
          if(val.length == 1) val = val[0];//If it's an array of 1, change into a single object
        }
        o[key] = val;//Map
      }

      return o;//Return parsed object
    };

    var settings = unescape(params);
    return settings;
  },

  onFilterUpdate: function(forceRedraw) {
    if(typeof forceRedraw === typeof undefined) forceRedraw = true;

    //Called by my children filters whenever they update at all, forces a redraw
    //and in turn will filter the products.

    //First, update the history state.
    var url = this.getFilteredUrl();
    //history.replaceState(this.getFilterSettings(), "", this.getFilteredUrl());
    //BHC THE ABOVE LIVE WAS REMOVED DUE TO GCLID PARAMETERS BEING REMOVED ON COLLECTION PAGES (added back in for this version as removed in live site only)

    //Next, queue a draw (essentially forces the products to filter)
    if(forceRedraw) this.queueDraw();

    //Update our facets
    for(var i = 0; i < this.facets.length; i++) {
      var facet = this.facets[i];
      facet.onValuesUpdated();
    }

    //Update our pagination
    if(typeof this.pagination !== typeof undefined) {
      this.pagination.onUpdate();
    }

    //Finally, trigger the event for subclasses
    this.onProductsFiltered();
  },

  //Filter events
  onProductsFiltered: function() {/* Called when the products are filtered. */ },


  /*
   *  Everything above this line is related to FILTERING the product information
   *  =========================================================================
   *  Everything below this line is related to FACETING the product information
   */
  addFacet: function(facet) {
    this.facets.push(facet);
  },

  removeFacet: function(facet) {
    var index = this.facets.indexOf(facet);
    if(index === -1) return;
    this.facets.splice(index, 1);
  },

  /*
   *  Everything above this line is related to FACETING the product information
   *  =========================================================================
   *  Everything below this line is related to SORTING the product information
   */
  attachSorter: function(e) {
    this.sorters = this.sorters || [];
    this.sorters.push(e);
    e.on('change', this.onSort.bind(this));
    e.html(this.getSorterCode());
  },

  setSort: function(sort) {
    this.sorting = sort;
    this.updateSorters();
    this.onFilterUpdate();
  },

  onSort: function(e, i, a, b) {
    window.lastEventForTest = e;
    var self = $(e.target);
    var val = self.val();
    var sort = AjaxCollectionSort[val];
    if(typeof sort === typeof undefined) return;
    this.setSort(sort);
  },

  updateSorters: function() {
    this.sorters = this.sorters || [];
    var code = this.getSorterCode();
    for(var i = 0; i < this.sorters.length; i++) {
      this.sorters[i].html(code);
    }
  },

  getSorterCode: function() {
    var keys = Object.keys(AjaxCollectionSort);
    var x = '';
    for(var i = 0; i < keys.length; i++) {
      var k = keys[i];
      var v = AjaxCollectionSort[k];
      if(typeof v.handle === typeof undefined) continue;
      if(typeof v.sort === typeof undefined) continue;
      if(typeof v.hide !== typeof undefined && v.hide === true) continue;
      if(typeof v.visible === 'function') {
        var result = v.visible(this);
        if(!result) continue;
      }
      var isSelected = this.sorting.handle === v.handle;
      x += this.getSortOptionCode(k, v, isSelected);
    };
    return x;
  },

  getSortOptionCode: function(sorterKey, sorter, isSelected) {
    var x = '';
    x += '<option value="'+sorterKey+'" '+(isSelected?'selected':'')+'>';
    x += (sorter.name||sorterKey).escapeHTML();
    x += '</option>';
    return x;
  }
};

/*
 *  Carousel
 *    Scripts for carousel
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    sections/carousel.liquid - Required for building carousel component.
 *
 *  Version:
 *    1.0.0 - 2018/01/25
 */
function Carousel(container) {
  this.container = container;
  this.id = container.data('section-id');
  window.carousels[this.id] = this;

  //Now read attributes
  this.options = {
    infinite: this.container.data('infinite') === true ? true : false,
    slidesToShow: this.container.data('slides-to-show') || 1,
    slidesToScroll: this.container.data('slides-to-scroll') || 1,
    autoplay: this.container.data('autoplay') == true,
    adaptiveHeight: true,
    dots: this.container.data('dots') == true,
    arrows: this.container.data('arrows') == true,
    autoplaySpeed: (this.container.data('autoplay-speed') * 1000) || 5000,
    speed: (this.container.data('slide-speed') * 1000) || 1500,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)'
  };
  this.slick = this.container.slick(this.options);
}

Carousel.prototype = {
  remove: function() {
    this.container.remove();
    delete window.carousels[this.id];
    delete window.carouselForceSlide[this.id];
  },

  getSlideElementFromBlock: function(block) {
    var element = this.container.find('[data-slide][data-block-id="'+block+'"]');
    return element;
  },

  getSlideIndexFromBlock: function(block) {
    var element = this.getSlideElementFromBlock(block);
    console.log(element);
    return parseInt(element.data('index'));
  },

  setSlide: function(slide) {
    this.container.slick('slickGoTo', slide);
  }
};

//Globals
window.carousels = window.carousels || {};
window.carouselForceSlide = window.carouselForceSlide || {};

//Events/Setup
$(document).ready(function() {
  $('[data-carousel]').each(function() {
    var self = $(this);
    if( window.carousels[self.data('section-id')] ) return;//Don't double up carousels
    if(self.hasClass('slick-initialized')) return;
    new Carousel(self);
  });
});

//Section events
$(document).on('shopify:section:load', '.c-section__carousel', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.carousels[id];
  if(typeof carousel !== typeof undefined) {
    carousel.remove();
  }
  carousel = new Carousel( $('[data-carousel][data-section-id="'+id+'"]') );
});

$(document).on('shopify:section:unload', '.c-section__carousel', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.carousels[id];
  if(typeof carousel === typeof undefined) return;
  carousel.remove();
  window.carouselForceSlide[id] = 0;
});

$(document).on('shopify:section:select', '.c-section__carousel', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.carousels[id];
  if(typeof carousel === typeof undefined) return;
  if(!window.carouselForceSlide[id]) return;
  carousel.setSlide( window.carouselForceSlide[id] );
});

$(document).on('shopify:block:select', '.c-section__carousel', function(e) {
  var section = e.detail.sectionId;
  var block = e.detail.blockId;
  var carousel = window.carousels[section];
  if(typeof carousel === typeof undefined) return;
  var index = carousel.getSlideIndexFromBlock(block);
  window.carouselForceSlide[section] = index;
  carousel.setSlide(index);
});

/*
 *  Icon Grid
 *    Icon Grid Section
 *
 *  Dependencies:
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/07/26
 */
function IconGrid(container) {
  this.container = container;

  this.container.on('click', '[data-icon-grid-icon][data-icon-grid-has-box]', this.onToggleBox.bind(this));
}

IconGrid.prototype = {
  onToggleBox: function(e) {
    e.preventDefault();
    e.stopPropagation();

    var self = $(e.currentTarget);
    var id = self.attr('data-block-id');
    var box = this.container.find('[data-icon-grid-box][data-block-id="'+id+'"]');

    var wasOpen = false;

    //Find the box that this clicked element belongs to.
    if(box.hasClass('is-open')) wasOpen = true;

    this.container.find('[data-icon-grid-icon]').removeClass('is-open');
    this.container.find('[data-icon-grid-box]').removeClass('is-open');

    if(wasOpen) return;

    self.addClass('is-open');
    box.addClass('is-open');
  }
};

$(document).ready(function() {
  $('[data-icon-grid]').each(function(e, i) {
    var self = $(this);
    var iconGrid = new IconGrid(self);
  });
});

/*
 *  Instagram
 *    Scripts for Instagram feeds
 *
 *  Dependencies:
 *    jQuery - Required for selectors
 *    Instafeed.JS - Used to manage the instagram integration
 *    sections/instagram.liquid
 *
 *  Version:
 *    1.0.0 - 2018/02/05
 */

var DEFAULT_INSTAGRAM_TEMPLATE = '<div class="c-instagram__photo-container"><a href="{{link}}" target="_blank" class="c-instagram__photo">';
DEFAULT_INSTAGRAM_TEMPLATE += '<img src="{{image}}" />';
DEFAULT_INSTAGRAM_TEMPLATE += '</a></div>';

var DEFAULT_INSTAGRAM_OPTIONS = {
  get: 'user',
  template: DEFAULT_INSTAGRAM_TEMPLATE,
  resolution: 'low_resolution'
}

function instagram(self) {
  if(self.hasClass('is-running')) return;
  var token = self.data('token');
  if(!token || !token.length) return;
  var spl = token.split('.');
  if(!spl.length) return;

  //Need a polyfill for Object.assign
  var newOptions = JSON.parse(JSON.stringify(DEFAULT_INSTAGRAM_OPTIONS));
  newOptions.userId = spl[0];
  newOptions.accessToken = token;
  newOptions.target = self.attr('id');
  newOptions.limit = self.data('limit') || 6;

  var feed = new Instafeed(newOptions);
  feed.run();
}

$(document).ready(function() {
  $('[data-instagram-feed]').each(function() {
    instagram($(this))
  })
});

//Section events
$(document).on('shopify:section:load', '.c-section__instagram', function(e) {
  var id = e.detail.sectionId;
  var feed = $('[data-instagram-feed][data-feed-id="'+id+'"]');
  instagram(feed)
});

$(document).on('shopify:section:unload', '.c-section__instagram', function(e) {
  var id = e.detail.sectionId;
  var feed = $('[data-instagram-feed][data-feed-id="'+id+'"]');
  if(!feed.hasClass('is-running')) return;
  feed.remove();
});

$(document).on('shopify:section:select', '.c-section__instagram', function(e) {
  var id = e.detail.sectionId;
});


/*==== Build as slick ====*/

$(window).on('load resize orientationchange', function() {
  $('[data-instagram-feed-wrap]').each(function(){
    var $shopBy = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 749) {
      if ($shopBy.hasClass('slick-initialized')) {
        $shopBy.slick('unslick');
      }
    }
    else{
      if (!$shopBy.hasClass('slick-initialized')) {
        $shopBy.slick({
          infinite: false,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          mobileFirst: true
        });
      }
    }
  });
});

/*
 *  Collection Shop By
 *    list of images linking to collection pages.
 *
 */

$(document).on('click', '[data-collection-view-btn]', function(e) {
  e.preventDefault();
  e.stopPropagation();
  var viewBtn = $ ('[data-collection-view-btn]');
  var content = $('[data-collection-icon]');
  var isContentVisible = content.hasClass('is-visible');

  if(isContentVisible) {
    content.removeClass('is-visible');
    //viewBtn.removeClass('is-visible');
  } else {
    content.addClass('is-visible');
    viewBtn.removeClass('is-visible');
  }
});


/*==== Build as slick ====*/


$(window).on('load resize orientationchange', function() {
  $('[data-collection-shop-by]').each(function(){
    var $shopBy = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 749) {
      if ($shopBy.hasClass('slick-initialized')) {
        $shopBy.slick('unslick');
      }
    }
    else{
      if (!$shopBy.hasClass('slick-initialized')) {
        $shopBy.slick({
          infinite: false,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          mobileFirst: true,
          slide: '.c-collection-shop-by__icon'
        });
      }
    }
  });
});

/*
 *  Collection Carousel
 *    Scripts and logic for the collection carousel.
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    sections/collection-carousel.liquid - Required for building the collection carousel.
 *
 *  Version:
 *    1.0.0 - 2018/01/31
 */

 // hack to make the first and last slide transparent
$('.c-collection-carousel__loop').on('mousedown', function(){
  var allSlides = $('.c-collection-carousel__loop .slick-slide');
  allSlides.css('opacity','1');
});
$('.c-collection-carousel__loop').on('mouseup', function(){
  var lastSlide = $('.c-collection-carousel__loop .slick-active').last().next();
  lastSlide.css('opacity','.5');
});

$('[data-collection-carousel]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  var allSlides = $('.c-collection-carousel__loop .slick-slide');
  allSlides.css('opacity','1');
});
$('[data-collection-carousel]').on('afterChange', function(event, slick, currentSlide, nextSlide){
  var lastSlide = $('.c-collection-carousel__loop .slick-active').last().next();
  lastSlide.css('opacity','.5');
});

function CollectionCarousel(container) {
  this.container = container;
  this.id = container.data('id');

  var options = {
    infinite: this.container.data('infinite') == false ? false : true,
    slidesToShow: this.container.data('slides-to-show') || 1,
    slidesToScroll: this.container.data('slides-to-show') || 1,
    autoplay: this.container.data('autoplay') == true,
    dots: this.container.data('dots') == true,
    arrows: this.container.data('arrows') == true,
    adapativeHeight: true,
    autoplaySpeed: this.container.data('autoplay-speed') || 5000,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    responsive: [
    {
        breakpoint: 749,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      }
    ]
  };


  this.slick = this.container.slick(options);

  window.collectionCarousels[this.id] = this;
}

CollectionCarousel.prototype = {
  remove: function() {
    this.container.remove();

  },

  setSlide: function(slide) {
    this.container.slick('slickGoTo', slide);
  }
};

window.collectionCarousels = window.collectionCarousels || {};

$(document).ready(function() {
  $('[data-collection-carousel]').each(function() {
    var self = $(this);
    if(window.collectionCarousels[self.data('id')] ) return;//Don't double up carousels
    if(self.hasClass('slick-initialized')) return;
    new CollectionCarousel(self);
  })
});

//Section events
$(document).on('shopify:section:load', '.c-section__collection-carousel', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.collectionCarousels[id];
  if(typeof carousel !== typeof undefined) {
    carousel.remove();
  }
  carousel = new CollectionCarousel( $('[data-collection-carousel][data-id="'+id+'"]') );
});

$(document).on('shopify:section:unload', '.c-section__collection-carousel', function(e) {
  var id = e.detail.sectionId;
  var carousel = window.collectionCarousels[id];
  if(typeof carousel === typeof undefined) return;
  carousel.remove();
});



/*
 *  Featured Content - Our Features
 *    Our Features section for the home page.
 *    Script for rotating image.
 */
function checkFeaturedAnimation() {
  window.requestAnimationFrame(checkFeaturedAnimation);

  var rotator = $('[data-our-features-rotator]');
  if(!rotator || !rotator.length) return;
  var container = $(document);
  var viewport = $(window);

  //Screen Width, is mobile?
  var isMobile = true;
  if ($(window).width() > 499) {
    isMobile = false;
  }


  //Settings for number of images in sprite & sprite width
  var images = 40;
  var spriteWidth;

  if(isMobile) {
    spriteWidth = 10830;
  } else {
    spriteWidth = 14440;
  }
  var imageWidth = spriteWidth / images;

  //Checking whether the element is in the visible window
  var scrollY = $(window).scrollTop();
  var scrollYBottom = scrollY + $(window).height();
  var elementTop = rotator.offset().top;
  if(elementTop > scrollYBottom) return;//Below bottom of screen
  var elementHeight = rotator.height() * 0.5;
  var elementBottom = elementTop + elementHeight;
  if(elementBottom < scrollY) return;//Above top of screen

  var totalHeight = $(window).height() + (elementHeight);
  var distanceFromTop = elementTop - scrollY-(elementHeight*2);
  var percent = ((totalHeight - distanceFromTop)/totalHeight) - 1;

  //Manipulate the sprite based on the percentage of the element is scrolled
  percent = percent * 1.45;

  var x = (-Math.floor(percent * images) * imageWidth);
  if(percent < 0) {
    rotator.css('background-position', '0 0'); //Ensure it never disappears above
  } else if(percent > 0.999) {
    rotator.css('background-position', '-' + (spriteWidth - imageWidth) + 'px 0'); //Ensure it never disappears
  } else {
    rotator.css('background-position', x + 'px 0');
  }

  /*console.log(`
    ======
    ScrollY: ${scrollY}
    Scroll Bottom: ${scrollYBottom}
    ElementTop: ${elementTop}
    ElementHeight: ${elementHeight}
    Element Bottom: ${elementBottom}
    distanceFromTop ${distanceFromTop}
    percent ${percent}
    ====
  `);*/
}

$(document).ready(checkFeaturedAnimation);

/*
 *  Header
 *    Scripts for the header section including custom search functionality.
 *
 *  Version:
 *    1.0.0 - 2019/04/04
 */
function HeaderSection(container) {
  this.container = container;
  this.navigation = container.find('[data-header-navigation]');

  this.container.on('click', '[data-header-search-button]', this.onToggleSearch.bind(this));

  $(document).on('onCartUpdate', this.onCartUpdate.bind(this));

  this.lastScrollTop = 0;
  $(document).on('scroll', this.onScroll.bind(this));
  this.onScroll.bind(this);

  this.container.on('mouseover', '.c-header__menu-link-item', this.expandHeader.bind(this));
  this.container.on('mouseout', '.c-header__menu-link-item', this.shrinkHeader.bind(this));
}

jQuery(window).scroll(function(){
  if(jQuery(this).scrollTop() > 300){
    jQuery(".c-header").addClass("is-sticky");
    jQuery("body").addClass("header-sticky");
  }
  else{
    jQuery(".c-header").removeClass("is-sticky");
    jQuery(".c-header__icons").removeClass("is-menu-open");
    jQuery(".c-mobile-menu__menu").removeClass("is-open");
    jQuery(".c-header").removeClass("is-block");
    jQuery("body").removeClass("header-sticky");
  }
});

HeaderSection.prototype = Object.assign(HeaderSection.prototype, {
  onCartUpdate: function(e, data) {
    var qty = 0;
    for(var i = 0; i < data.items.length; i++) {
      var item = data.items[i];
      qty += item.quantity;
    }
    this.container.find('[data-cart-counter]').text(qty);
  },

  onToggleSearch: function(e) {
    e.preventDefault();
    e.stopPropagation();

    this.navigation.toggleClass('is-search');

    // After the animation delay, if it is visible, focus
    if (this.navigation.hasClass('is-search')) {
        setTimeout( () => this.navigation.find('.c-header-search__input').focus(), 300)
    };

    if(!this.navigation.hasClass('is-search')) {
      $('.algolia-autocomplete').css('display', 'none');
    }
  },

  checkScrollTop: function(){
    if($(window).scrollTop() >= 150){
      this.container.addClass('sticky-on');
    }else{
      this.container.removeClass('sticky-on');
    }

    // if($(window).scrollTop() >= 80 && $(window).scrollTop() < 150){
    //   this.container.addClass('sticky-control');
    // }else{
    //   this.container.removeClass('sticky-control');
    // }
  },

  onScroll: function(e){
    this.checkScrollTop();

    var st = $(window).scrollTop();

    if (st > this.lastScrollTop){
        // downscroll code
        this.container.removeClass('is-sticky');

    } else {
      // upscroll code
      this.container.addClass('is-sticky');

    }
    this.lastScrollTop = st;
  },

  expandHeader: function(e) {
    if(this.container.hasClass('is-block') || !this.container.hasClass('sticky-on')) return;
    this.container.addClass('is-block');
  },

  shrinkHeader: function(e) {
    if(!this.container.hasClass('is-block') || !this.container.hasClass('sticky-on')) return;
    this.container.removeClass('is-block');
  }
});

$(document).ready(function() {
  $('[data-header]').each(function(i,e) {
    var header = new HeaderSection($(e));
  });
});

/*
 *  Collection Shop By
 *    list of images linking to collection pages.
 *
 */

/*==== Build as slick ====*/

$(window).on('load resize orientationchange', function() {
  $('[data-home-about-timeline-wrap]').each(function(){
    var $shopBy = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 749) {
      if ($shopBy.hasClass('slick-initialized')) {
        $shopBy.slick('unslick');
      }
    }
    else{
      if (!$shopBy.hasClass('slick-initialized')) {
        $shopBy.slick({
          infinite: false,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          mobileFirst: true
        });
      }
    }
  });
});


function HistoryAnimation() {
  //Elements
  this.historyTimeline = $('[data-home-about-timeline-wrap]');
  if(!this.historyTimeline.length) return;

  //Events
  $(window).on('resize', this.onResize.bind(this));
  $(window).on('scroll', this.onScroll.bind(this));

  this.determineTabletUp();
}

HistoryAnimation.prototype = {
  isScrolledTo: function(elem) {
    if(!this.isTabletUp) return false;

    //Have we scrolled to the element?
    var docViewTop = $(window).scrollTop(); //num of pixels hidden above current screen
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(elem).offset().top; //num of pixels above the elem
    if(elemTop > docViewBottom) return false;//Below bottom of screen
    return true;
  },

  determineTabletUp: function() {
    var windowSize = $(window).width();
    //Check if this screen size is tablet size or larger
    if (windowSize < 750) this.isTabletUp = false;
    this.isTabletUp = true;
    return this.isTabletUp;
    console.log(isTabletUp);
  },

  onResize: function(e) {
    this.determineTabletUp();
  },

  onScroll: function() {
    if(!this.isTabletUp) return;

    //Have we scrolled the bar into view?
    if(this.isScrolledTo(this.historyTimeline)) {
      $('[data-timeline-bar]').delay(0).queue(function(){
        $(this).addClass("timeline-is-visible");
      });
      $('[data-timeline-entry-1]').delay(0).queue(function(){
        $(this).addClass("timeline-is-visible");
      });
      $('[data-timeline-entry-2]').delay(500).queue(function(){
        $(this).addClass("timeline-is-visible");
      });
      $('[data-timeline-entry-3]').delay(1000).queue(function(){
        $(this).addClass("timeline-is-visible");
      });
      $('[data-timeline-entry-4]').delay(1500).queue(function(){
        $(this).addClass("timeline-is-visible");
      });
      $('[data-timeline-entry-5]').delay(2000).queue(function(){
        $(this).addClass("timeline-is-visible");
      });
    }
  }
}

$(document).ready(function() {
  new HistoryAnimation();
});

/*
 *  Collection Shop By
 *    list of images linking to collection pages.
 *
 */

/*==== Build as slick ====*/

/*
$(window).on('load resize orientationchange', function() {
  $('[data-home-featured-in-wrap]').each(function(){
    var $shopBy = $(this);
    /// Initializes a slick carousel only on mobile screens
    // slick on mobile
    if ($(window).width() > 749) {
      if (!$shopBy.hasClass('slick-initialized')) {
        $shopBy.slick({
          infinite: true,
          arrows: false,
          slidesToShow: 6,
          slidesToScroll: 1,
          mobileFirst: true
        });
      }
    }
    else{
      if (!$shopBy.hasClass('slick-initialized')) {
        $shopBy.slick({
          infinite: true,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          mobileFirst: true
        });
      }
    }
  });
});
	
*/
/*
 *  Mobile Menu
 *    Contains the scripts for the mobile menu, including accordion design
 *
 *  Dependencies:
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/07/10
 */

//Global Menu Toggle Click Listener
$(document).on('click touchend', '[data-mobile-menu-toggle]', function(e) {
  e.preventDefault();
  e.stopPropagation();
  var header = $('[data-header]');
  var menu = $('[data-mobile-menu]');
  var buttons = $('[data-mobile-menu-toggle]');
  var isMenuOpen = menu.hasClass('is-open');

  if(isMenuOpen) {
    menu.removeClass('is-open');
    buttons.removeClass('is-menu-open');
    header.removeClass('is-block');
  } else {
    menu.addClass('is-open');
    buttons.addClass('is-menu-open');
    header.addClass('is-block');
  }
});

// added from client's production
$(document).on('click touchend', '[data-mobile-menu-toggle]', function(e) {
  if(jQuery(this).hasClass("is-menu-open")){
    jQuery("body").addClass("make-overflow");
    
    jQuery(".bf-meeting-widget a, #gorgias-web-messenger-container").stop().fadeOut();
  }
  else{
    jQuery("body").removeClass("make-overflow");
    jQuery(".bf-meeting-widget a, #gorgias-web-messenger-container").stop().fadeIn();
  }
})
// end: added from client's production

$(document).on('click', '[data-mobile-menu-link]', function(e) {
  var self = $(this);
  self.toggleClass('is-open');
  var submenu = self.parent().find('[data-mobile-menu-submenu]');
  if(!submenu.length) return;

  e.preventDefault();
  e.stopPropagation();
  submenu.toggleClass('is-open');
});


$(document).on('click', '[data-mobile-menu-submenu-link]', function(e) {
  var self = $(this);
  self.toggleClass('is-open');
  var subsubmenu = self.parent().find('[data-mobile-menu-subsubmenu]');
  if(!subsubmenu.length) return;

  e.preventDefault();
  e.stopPropagation();
  subsubmenu.toggleClass('is-open');
});

/*
*  Product Buy Now Button
*    Button at bottom of product page, redirects to the variant selection.
*
*  Version:
*    1.0.0 - 2019/01/25
*/

$("[data-btn-buy-now]").click(function() {
  $('html,body').animate({
    scrollTop: $("[data-product-title]").offset().top},'slow');
});

/*
 *  Product Carousel
 *    Product Carousel Scripts
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *
 *  Version:
 *    1.0.0 - 2019/01/24
 */
function ProductCarousel(container) {
  this.container = container;
  this.id = this.container.attr('data-id') || Math.floor(Math.random()*10000);

  this.carousel = this.container.find('[data-product-carousel-carousel]');
  this.navigation = this.container.find('[data-product-carousel-navigation]');

  //Add ID classes
  this.carousel.addClass('c-product-carousel__carousel--'+this.id);
  this.navigation.addClass('c-product-carousel__navigation--'+this.id);

  //Nav Options
  this.navOptions = this.container.find('[data-product-carousel-nav]');

  // Variant image
  this.variantImage = this.container.data('variant-image-id');

  //Carousel Slick
  var options = {
    infinite: true,
    slidesToShow: this.container.data('slides-to-show') || 1,
    slidesToScroll: this.container.data('slides-to-scroll') || 1,
    autoplay: this.container.data('autoplay') == true,
    dots: true,
    arrows: true,
    autoplaySpeed: this.container.data('autoplay-speed') || 5000,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    adaptiveHeight: this.container.data('adaptiveHeight') == false ? false : true,
    draggable:false,
    fade: true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          dots: true,
          arrows: true,
          draggable: true
        }
      }
    ]
  };



    //Navigation Slick
    this.navigationSlick = this.navigation.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false,
      focusOnSelect: true,
      asNavFor: '.c-product-carousel__carousel--'+this.id,
      centerMode: false,
      vertical: false,
      verticalSwiping: false,
      draggable: true,
      adaptiveHeight: false
    });

  options.asNavFor = '.c-product-carousel__navigation--'+this.id;

  this.slick = this.carousel.slick(options);
  this.adjustSlideColors();

  this.carousel.on('afterChange', this.adjustSlideColors.bind(this));
  this.carousel.on('beforeChange', this.adjustSlideColors.bind(this));

  window.productCarouselsArr.push(this);
  window.productCarousels[this.id] = this;

  this.container.attr("data-initialized", true);

  $('.slick-slide[data-image-id="'+this.variantImage+'"]').trigger('click');
}

ProductCarousel.prototype = {
  remove: function() {
    var index = window.productCarouselsArr.indexOf(this);
    window.productCarouselsArr.splice(index, 1);
    this.container.remove();
  },

  getCurrentSlide: function() {
    return this.carousel.slick('slickCurrentSlide');
  },

  adjustSlideColors: function() {
    this.navOptions.removeClass('slick-current');
    this.navOptions
      .filter('[data-product-carousel-index="'+this.getCurrentSlide()+'"]')
      .addClass('slick-current')
    ;
  },

  goToSlide: function(slide) {
    this.adjustSlideColors();
    this.carousel.slick('slickGoTo', slide);
  }
}

window.productCarouselsArr = window.productCarouselsArr || [];
window.productCarousels = window.productCarousels || {};

$(document).ready(function() {
  $('[data-product-carousel]').each(function() {
    var self = $(this);
    if(self.attr('data-initialized')) return;
    var carousel = new ProductCarousel(self);
  })
});


function ProductMeasurePopup(template) {

  //ProductTemplate Javascript Object

  this.template = template;



  //Get our container

  this.container = this.template.container.find('[data-measure-popup]');



  //Elements

  this.carousel = $('[data-measure-popup-carousel]');



  {

    //Now load in the CSV data from the section...

    var rows = Papa.parse(SizeData, { skipEmptyLines: true, dynamicTyping: true, fastMode: false }).data;

    console.log('rows',rows);


    //Now transform the data into a format we can use

    var flatten = {};//Where to store the flattened data

    for(var i = 1; i < rows.length; i ++) {

      //Foreach row i the CSV...

      var row = rows[i];//Where row[x] = column x

      if(row.length < 6) continue;

      if(row[0].replace(/\s/g, '').length == 0) continue;



      var typeName = row[0].trim();//First column

      var pointName = row[1].trim();

      var sizeName = row[2];

      var minVal = row[3];

      var maxVal = row[4];

      var description = row[5];

      var image = row[6];



      //Check if this type was defined on a previous loop..

      var type = flatten[typeName];

      if(typeof type === typeof undefined) {

        flatten[typeName] = type = {};//Not defined (this is the first row of this type)

      }



      //Same as above, but for size within this type e.g. "Type_a, size 1, Type_a, size 2, Type_b size 1"...

      var size = type[sizeName];

      if(typeof size === typeof undefined) {

        type[sizeName] = size = {};

      }



      //Create a point if it's not already existing for this size.

      var point = size[pointName];

      if(typeof point !== typeof undefined) continue;

      size[pointName] = point = {

        min: minVal,

        max: maxVal,

        description: description,

        image: image

      };

    }



    //Now store the data

    this.data = flatten;



    //Attempt to find the type for this product (base don tag)

    var prod = this.template.data;//Temporarily store product data

    var group = null;

    for(var i = 0; i < prod.tags.length; i++) {

      var tag = prod.tags[i];

      var tagSplit = tag.split('_');//e.g. Product_Test Type_Lorem



      //Is this a Product_ tag? .shift() will remove the prefix from the array

      if(!tagSplit.length || tagSplit.shift() != 'Product') continue;



      //Since shift removed the prefix (e.g. ["Produt", "Lorem Ipsum"] is now [ "Lorem Ipsum" ]

      var t = tagSplit.join('_');//Join by underscore, should fix any stray bits they've left

      if(typeof this.data[t] === typeof undefined) continue;//Do we have this type?

      //Yes! convert to lower case then compare.

      group = this.data[t];

      break;

    }

    if(!group) {



      return console.error('Failed to find sizing group for this product, have you tagged it?');

    }



    this.group = group;//Store.

  }



  //Okay we're ready to build the form...

  this.step = 0;//Holds the current step, 0 = First Step, 1 = second etc.

  this.stepCount = 3; // 3 Step Process

  this.measureSteps = new ProductMeasureSteps(this);//Create the internal steps-steps



  //Slick

  this.carousel.slick({

    slidesToShow: 1,

    slidesToScroll: 1,

    arrows: false,

    dots: false,

    draggable: false,

    touchMove: false,

    swipe: false,

    adaptiveHeight: true,

    infinite: false,

    autoplay: false,
    accessibility: false
  });



  //Events

  this.template.container.on('click', '[data-measure-popup-next]', this.next.bind(this));

  this.template.container.on('click', '[data-measure-popup-back]', this.prev.bind(this));

  this.template.container.on('click', '[data-measure-popup-start]', this.start.bind(this));

  this.carousel.on('afterChange', this.onAfterChange.bind(this));

  $(window).on('resize', this.onResize.bind(this));

  $(document).on('onVariantChange', this.onVariantChange.bind(this));

  $(document).on('load', this.refreshCarousel.bind(this));

  $(window).on('load', this.refreshCarousel.bind(this));



}



ProductMeasurePopup.prototype = Object.assign(ProductMeasurePopup.prototype, {

  show: function() {

    //Show popup.

    this.goToStep(0);

    this.measureSteps.goToStep(0);

    $('html,body').addClass('is-popup-open');

    this.container.addClass('is-active');

  },



  close: function() {

    this.goToStep(0);

    this.measureSteps.goToStep(0);

    $('html,body').removeClass('is-popup-open');

    this.container.removeClass('is-active');

  },



  goToStep: function(step) {

    this.step = step;

    //if(this.step < 2) this.measureSteps.goToStep(0);

    this.carousel.slick('slickGoTo', step);

    this.updateProgress();

  },



  next: function() {

    if(this.step >= this.stepCount-1) return;

    this.goToStep(this.step + 1);

  },



  prev: function() {

    if(this.step == 0) return;

    this.goToStep(this.step - 1);

  },



  start: function() {

    this.goToStep(1);

    this.measureSteps.goToStep(0);

  },



  refreshCarousel: function() {

    if(!this.carousel) return;

    this.carousel.slick('slickSetOption', 'arrows', 'false', true);

    this.carousel.slick('setPosition', this.step);

    this.measureSteps.refreshCarousel();

    this.updateProgress();

  },



  updateProgress: function() {
    var bar = this.container.find('[data-measure-popup-progress]');
    var percent = (this.measureSteps.step+1) + (this.step - 1);  
    var currentPercent = percent;

    percent /= (this.measureSteps.getStepCount()+1);
    var w = bar.parent().width() * percent;

    // bar.width(w);

    // progress Line
    this.container.find('.sub-line').removeClass('active');

    for ( var i = 0; i <= currentPercent; i++ ){
      this.container.find(`.sub-line[data-index="${i}"]`).addClass('active');
    }

  },



  onResize: function(e) { this.refreshCarousel(); },

  onAfterChange: function(e) { setTimeout(this.refreshCarousel.bind(this), 16); },

  onVariantChange: function(e, id, variant) {

    var image = this.template.data.featured_image;

    if(variant.featured_image && variant.featured_image.src) image = variant.featured_image.src;

    if(!image) return;



    var img = ImageTools.generatePicture(image, 800, [200, 400], 'c-measure-popup__form-picture-image');

    var imageContainer = this.container.find('[data-measure-form-image]');



    //Image load was causing slick height to be off, let's listen for image load

    //and refresh the carousel height

    imageContainer.html(img);

    var imageToBeLoaded = this.container.find('img');

    imageToBeLoaded.load(this.refreshCarousel.bind(this));



    this.refreshCarousel();

  }

});


function ProductMeasureSteps(popup) {
  this.popup = popup;
  this.container = this.popup.container.find('[data-measure-popup-measure-step]');

  this.step = 0;
  //this.stepCount //dynamically from the product measurements

  this.print();
  this.container.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    draggable: false,
    touchMove: false,
    adaptiveHeight: true,
    infinite: false,
    swipe: false,
    autoplay: false,
    accessibility: false
  }).on('init', function(event, slick) {
    // Initialize the nested/slick slider for the first slide
    $(slick.$slides[0]).find('.measure-product-images-slider').slick({
      // Options for the nested/slick slider
      // ...
    });
  }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    // Destroy the current nested/slick slider before changing slide
    $(slick.$slides[currentSlide]).find('.measure-product-images-slider').slick('unslick');
  }).on('afterChange', function(event, slick, currentSlide) {
    // Initialize the nested/slick slider for the current slide
    $(slick.$slides[currentSlide]).find('.measure-product-images-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      draggable: false,
      touchMove: false,
      adaptiveHeight: true,
      infinite: true,
      swipe: false,
      autoplay: false
    });
  });

  

  //Where key = measure point and value = measurement
  this.settings = {};

  //Listeners
  this.container.on('change keypress keyup keydown cut copy paste focusin focusout blur', '[data-measurement-input]', this.onMeasurementChange.bind(this));
  this.container.on('click', '[data-measure-step-back]', this.onPrevClick.bind(this));
  this.container.on('click', '[data-measure-step-next]', this.onNextClick.bind(this));
  this.container.on('afterChange', this.onAfterChange.bind(this));
  $(window).on('resize', this.onResize.bind(this));
}

ProductMeasureSteps.prototype = Object.assign(ProductMeasureSteps.prototype, {
  getData: function () { return this.popup.group; },

  getSizes: function() {
    return Object.keys(this.getData());
  },

  getMeasurePoints: function() {
    var data = this.getData();
    var sizes = Object.keys(data);
    var measures = [];
    for(var i = 0; i < sizes.length; i++) {
      var x = data[sizes[i]];
      var measuresAtSize = Object.keys(x);
      for(var y = 0; y < measuresAtSize.length; y++) {
        var mas = measuresAtSize[y];
        if(measures.indexOf(mas) !== -1) continue;
        measures.push(mas);
      }
    }
    return measures;
  },

  getMeasureData: function(size, measurePoint) {
    if(typeof size === typeof undefined || !size) size = this.getSizes()[0];
    return this.getData()[size][measurePoint];
  },

  getStepCount: function() {
    return this.getMeasurePoints().length;
  },

  goToStep: function(step) {
    this.step = step;
    this.container.slick('slickGoTo', step);
    this.popup.updateProgress();
  },

  next: function() {
    if(this.step >= this.getStepCount()-1) {
      
      //What happens after you reach the final step.
      //Calculate based on this.settings.

      //Determine size....
      console.log('Determining Size...');
      var sizes = this.getSizes();
      console.log('sizes',sizes);
      var selectedSizes = [];
      var selectedLength = [];
      var cmData = [];
      var html = ``;
      for(var i = 0; i < sizes.length; i++) {
        var sn = sizes[i];//Size Name
        var measureData = this.getData()[sn];//Measurement data for this size
        var measureNames = Object.keys(measureData);//List of measurement names
        var match = 0;
        for(var x = 0; x < measureNames.length; x++) {
          var mn = measureNames[x];//Measurement Name
          var md = measureData[mn];//Measure Data for this point
          
          //Is measurement set?
          if(typeof this.settings[mn] === typeof undefined) break;

          //Get Users measurement CHECK WITH DOM
          var mpv = parseFloat(this.settings[mn]).toFixed(1);

          //Is in range?
          if(mpv < md.min) break;//No match
          if(mpv > md.max) break;//No match

          //In range
          match++;
        }
        //Did all match range?
        if(match < measureNames.length) continue;//Do next size to see.
        console.log('this.settings',this.settings);
        var productVarData = this.getData();
        var cmData = productVarData[sn];
        for(var z = 0; z < measureNames.length; z++) {
          console.log(`${measureNames[z].split(" ")[0]}`);
          selectedLength.push(`${measureNames[z]} : ${cmData[measureNames[z]].min}-${cmData[measureNames[z]].max}`);
        }
        //This size matches
        selectedSizes.push(sn);
      }
      console.log("selected_length",selectedLength);
      function printDataInHTML(data) {
      const container = $('<div>');
      var html = ``;
      var tm,key,val;
      var k = [];
      for (const item of data) {
      var itms = item ;
      itms = itms.replace(/[{}]/g, '');
      tm = itms.split(":");
      key = tm[0].split(" ");
      key = key[0];
      val = tm[1];
      if(html.indexOf(key) > -1){
      }
      else{
      html += `<div class="item-variant ${key}"><span class="vatiany-title text-sm">${key} cm</span><span class="vatiany-value h4"></span></div>`;
      }
      k.push(key);
      }


      var uniqueChars = [...new Set(k)];
      for(const value of uniqueChars) {
      if($(".perfect-fit-details .product-variant .item-variant").hasClass(value)){
      }
      else{
      $(html).insertAfter(".perfect-fit-details .product-variant .item-variant");
      }
      }
      }
      printDataInHTML(selectedLength);
      var data_cm = selectedLength;
      for (const values of data_cm) {
          var data_cms = values;
          var dt = data_cms.split(" : ");
          var key_d =  dt[0];
          var val__d = dt[1];
          key_d = key_d.split(" ")[0];
          console.log("k",key_d , val__d);
          $(".perfect-fit-details .product-variant .item-variant").each(function(){
            var _____this = $(this);
            if(_____this.hasClass(key_d)){
              _____this.find(".vatiany-value").text(val__d);
            }
            });
      }

      var popup_container = this.popup.container[0];
      popup_container.querySelector(".perfect-fit-details .item-variant .vatiany-value").innerHTML = selectedSizes;

      // <div class="item-variant"><span class="vatiany-title">Size</span><span class="vatiany-value">5</span></div>

      var multipleMatches = selectedSizes.length > 1
      if(!selectedSizes.length || multipleMatches) {
        //Size did not match at all (none found)
        this.goToStep(this.getStepCount());
        //Add additional message, i.e. "You've matched multiple sizes"
        var popupElem = $('[data-measure-popup]')
        if(multipleMatches) {
          console.log('Multiple matches found in the Size Data CSV.');
          popupElem.addClass('has-multiple-matches')
        } else {
          console.log('No suitable size found from the measurements in the Size Data CSV.');
          popupElem.removeClass('has-multiple-matches')
        }

        return;
      }

      //Determine size index in options.
      var prodData = this.popup.template.data;
      var sizeIndex = -1;
      for(var i = 0; i < prodData.options.length; i++) {
        var on = prodData.options[i];
        if(on.toLowerCase() != 'size') continue;
        sizeIndex = i;
        break;
      }
      if(i === -1) {
        //Go to no size step
        this.goToStep(this.getStepCount());
        console.log('No match on size options. Check your product data has an option name of size.')
        return;//No match...?
      }

      //Chance that the "Selected Size" may return more than 1 size
      //If so we need to display a message and not worry about finding the
      //variant data. Text that the client can modify from the customiser.

      //This is where it is finding a size based on the data from the function above
      //Selected size will always return the column "Size" in the CSV, i.e. M Normal short

      //Swatch behind modal on product page
      var swatch = null;
      var selectorString = '';

      var selectedOptions = selectedSizes.join().split(' ')

      //Keep it the same if only one was entered
      if(selectedOptions.length == 1) {
        swatch = $('[data-swatch][data-value="'+selectedOptions[0].toLowerCase()+'"][data-swatch-position="'+(sizeIndex+1)+'"]');
        if(!swatch.length) {
          console.log('No suitable option was found for the selector: [data-swatch][data-value="'+selectedOptions[0].toLowerCase()+'"][data-swatch-position="'+(sizeIndex+1)+'"]');
        }
        window.swatch.setVariantFromSwatch(swatch, swatch.attr('data-value'));
      } else {
        //Else iterate through all swatches and find what we're looking for
        for(var i = 0; i < selectedOptions.length; i ++) {
          var thisOption = selectedOptions[i].toLowerCase();
          var thisSwatch = $('[data-swatch][data-value="'+thisOption+'"]');
          selectorString += '[data-option'+thisSwatch.attr('data-swatch-position')+'="'+thisOption+'"]';
        }

        var variantSelectorOption = $('[data-product-select]').find('[data-variant-option]'+selectorString);
        var variantID = variantSelectorOption.val();

        if (variantID) {
          var targetData = window.VariantSelector.getVariantData(variantID);
          if(typeof targetData === typeof undefined) return;
          $(document).trigger('onVariantChange',[variantID,targetData]);
        } else {
          console.log('No suitable option was found for the selector: [data-variant-option]'+selectorString);
        }
      }

      //Size matched (select in form)
      return this.popup.next();
    }
    this.goToStep(this.step + 1);
  },

  prev: function() {
    if(this.step == 0) return this.popup.prev();
    this.goToStep(this.step - 1);
  },

  print: function() {
    var __this = this;
    //Build HTML
    var x = '';

    var data = this.getData();
    var measures = this.getMeasurePoints();
    for(var i = 0; i < measures.length; i++) {
      //Measurement title
      var m = measures[i];

      //Get generic measure data...
      var md = this.getMeasureData(null, m);
      //md = { min: x, max: y, description: '', ... } don't use min and max.

      //Set placeholder text based on what's in the string
      var placeholder = 'Enter measurement';
      var descriptionString = md.description.toLowerCase();

      if(descriptionString.indexOf('measure') !== -1) {
        placeholder = 'Measurement in cm';
      } else if (descriptionString.indexOf('shoe size') !== -1) {
        placeholder = 'Shoe size';
      }

      //Generate the html for each measure
      x += '<div>';

        x += '<div class="measure-popup-main">';
          {
            x += '<div class="c-measure-popup__progress">';
            x += '<ul class="measure-subprogress">';
            x +=  '<li class="sub-line" data-index="0" data-measure-popup-progress></li>';
              x +=  '<li class="sub-line" data-index="1" data-measure-popup-progress></li>';
              x += '<li class="sub-line" data-index="2" data-measure-popup-progress></li>';
              x += '</ul>';
            x += '</div>';
            x += '<div class="c-measure-popup__buttons-btn is-left previous-button">';
              x += '<button type="button" data-measure-step-back class="o-btn c-product-measure__back is-back text-md">';
                x += '<img src="https://cdn.shopify.com/s/files/1/0109/0663/2256/files/Vector_10.png?v=1687520012" class="c-measure-popup__icon-back-img">';
                x += 'Previous';
              x += '</button>';
            x += '</div>';
          }
        
          x += '<div class="measure-sub">';

          x += '<div class="c-measure-popup__content">';
          //Left  (Image)
          {
            x += '<div class="c-measure-popup__content-col is-left">';
              x += '<h3 class="c-measure-popup__step-title h4">Measure '+m.escapeHTML()+'</h3>';
              x += '<p class="c-measure-popup__measure-description">';
              x += md.description.escapeHTML().replace(/\n/g, '<br />');
            x += '</p>';
              x += '<div class="c-measure-popup__col-content">';
                x += '<div class="c-measure-popup__col-img">';
                  if(md.image && md.image.length) {
                    x += ImageTools.generatePicture(
                      md.image,
                      800,
                      [200,400],
                      'c-measure-popup__col-img-image'
                    );
                  }
                x += '</div>';
                x += '<div class="c-measure-popup__input-row">';
                x += '<input type="number" placeholder="00" min="0" type="text" class="o-form__input o-form__input--rounded c-measure-popup__input" data-measurement-input data-measurement="'+m.escapeHTML()+'"/>';
                x += '<span class="h4">cm</span>';
              x += '</div>';
              x += '</div>';
            x += '</div>';
          }
          //Right (Form and deets)
          x += '</div>';
          //Buttons
          x += '<div class="c-measure-popup__buttons">';
          {
            x += '<div class="c-measure-popup__buttons-btn is-left previous-button mobile-previos-btn">';
              x += '<button type="button" data-measure-step-back class="o-btn c-product-measure__back is-back text-md">';
                x += '<img src="https://cdn.shopify.com/s/files/1/0109/0663/2256/files/Vector_10.png?v=1687520012" class="c-measure-popup__icon-back-img">';
                x += 'Previous';
              x += '</button>';
            x += '</div>';
            x += '<div class="c-measure-popup__buttons-btn is-right">';
              x += '<button type="button" data-measure-step-next data-measurement="'+m.escapeHTML()+'" ';
                x += 'class="o-btn button primary-button" disabled="disabled"'
              x += '>';
                x += '<span class="c-measure-popup__btn-msg--measure">Enter Measurement</span>';
                x += '<span class="c-measure-popup__btn-msg--continue">Continue <span class="c-measure-popup__arrow"></span></span>';
              x += '</button>';
            x += '</div>';
          }
          x += '</div>';

          x += '</div>';

        x += '</div>'
      x += '</div>'
    }

    //Extra step (for when the sizings don't match)
    X = ``;
    x += '<div>';
      x += '<div class="c-measure-popup__content contact-last-slide">';
        x += '<div class="c-measure-popup__content-col is-left">';
          x += '<div class="product-left-images">';
          x += '</div>'; 
          // x += '<h3 class="c-measure-popup__step-title">'+window.SizeStrings.noMatchTitle.escapeHTML()+'</h3>';
          // x += '<p class="c-measure-popup__multiple-match-text">';
          //   x += window.SizeStrings.multipleMatchBody.escapeHTML().replace(/\n/gi, '<br />');
          // x += '</p>'
          // x += '<p>';
          //   x += window.SizeStrings.noMatchBody.escapeHTML().replace(/\n/gi, '<br />');
          // x += '</p>'
        x += '</div>';
        x += '<div class="right-measurment-info">';
          x += '<h3 class="measurment-heading text-xl">Your measurements</h3>'
          x += '<div class="measurment-size-wrapper">'
            x += '<div class="left-size-info">'  
    if(md.image && md.image.length) {
                x += ImageTools.generatePicture(
                  md.image,
                  800,
                  [200,400],
                  'c-measure-popup__col-img-image'
                );
              }
              // x += '<img src="https://cdn.shopify.com/s/files/1/0109/0663/2256/files/knee-icon.png?v=1687519121">'
              x += '<div class="actual-size">'  
                    // x += '<div class="upper-size">'  
                    //   x += `<p class="text-lg">39</p><span class="size-text text-lg">cm - Upper</span>`  
                    // x += '</div>'
                    // x += '<div class="lower-size">'  
                    //   x += `<p class="text-lg">28</p><span class="size-text text-lg">cm - Lower</span>`  
                    // x += '</div>'
              x += '</div>'
            x += '</div>'
            x += '<div class="right-measure-again">'
              x += '<a data-measure-step-back class="measure-again-link">'
              x += '<p>Measure again</p>'
              x += '<img src="https://cdn.shopify.com/s/files/1/0109/0663/2256/files/refresh-Icon.svg?v=1687516462">'   
              x += '</a>'
            x += '</div>'  
          x += '</div>'
          x += '<div class="contact-info-border">'
          x += '</div>'
          x += '<div class="contact-info-text">'
              x += '<h3 class="c-measure-popup__step-title text-xl">'+window.SizeStrings.noMatchTitle.escapeHTML()+'</h3>';
              x += '<p class="c-measure-popup__multiple-match-text">';
                x += window.SizeStrings.multipleMatchBody.escapeHTML().replace(/\n/gi, '<br />');
              x += '</p>'
              x += '<p>';
                x += window.SizeStrings.noMatchBody.escapeHTML().replace(/\n/gi, '<br />');
              x += '</p>'
          x += '</div>';
          x += '<div class="contact-info-border">'
          x += '</div>'
          x += '<div class="three-btns-contact">';
            x += '<a href="tel:1300 668 466" class="o-btn button secondary-button" tabindex="0">Call us</a>'
            x += '<a href="mailto:info@bauerfeind.com.au" class="o-btn button secondary-button" tabindex="0">Email us</a>'
            x += '<a href="https://wa.me/61499885514" target="_blank" rel="noreferrer noopener" class="o-btn button secondary-button" tabindex="0">Whatsapp</a>'
          x += '</div>';  
          x += '<div class="contact-info-border">'
          x += '</div>'
          x += '<div class="measurment-infobar">';  
            x += '<div class="info-flex">'
              x +='<div class="left-icon">'
                x += '<img src="//cdn.shopify.com/s/files/1/0109/0663/2256/files/check-broken.svg?v=1686642452" class="lazyload">'
              x += '</div>'
              x += '<div class="right-heading text-xs">'
                x += 'Perfect fit'
              x += '</div>'
            x += '</div>'

            x += '<div class="info-flex">'
              x +='<div class="left-icon">'
                x += '<img src="//cdn.shopify.com/s/files/1/0109/0663/2256/files/currency-coin-dollar.svg?v=1686642601" class="lazyload"> '
              x += '</div>'
              x += '<div class="right-heading text-xs">'
                x += 'money back guarantee'
              x += '</div>'
            x += '</div>'

            x += '<div class="info-flex">'
              x +='<div class="left-icon">'
                x += '<img src="//cdn.shopify.com/s/files/1/0109/0663/2256/files/delivery.svg?v=1686642603" class="lazyload">'
              x += '</div>'
              x += '<div class="right-heading text-xs">'
                x += 'Fast delivery'
              x += '</div>'
            x += '</div>'

            x += '<div class="info-flex">'
              x +='<div class="left-icon">'
                x += '<img src="//cdn.shopify.com/s/files/1/0109/0663/2256/files/Group_12662.svg?v=1686642390" class="lazyload">'
              x += '</div>'
              x += '<div class="right-heading text-xs">'
                x += 'Made in germany'
              x += '</div>'
            x += '</div>'

          x += '</div>';
        x += '</div>';
      x += '</div>';

    x += '</div>';
    var measure_data_result_add = this.popup.container.find(".measure___wrap[data-mesure-from-js]");
    var measure_fit_data_result_add = this.popup.container.find(".perfect-fit-main");
    var measure_data_r = '';
    measure_data_r += '<h3 class="measurment-heading text-xl">Your measurements</h3>';
    measure_data_r += '<div class="measurment-size-wrapper">';
    measure_data_r += '<div class="left-size-info">';
    if (md.image && md.image.length) {
      measure_data_r += ImageTools.generatePicture(
        md.image,
        800,
        [200, 400],
        'c-measure-popup__col-img-image'
      );
    }
      measure_data_r += '<div class="actual-size">';
      measure_data_r += '</div>';
      measure_data_r += '</div>';
      measure_data_r += '<div class="right-measure-again">';
      measure_data_r += '<a data-measure-popup-back class="measure-again-link">';
      measure_data_r += '<p>Measure again</p>';
      measure_data_r += '<img src="https://cdn.shopify.com/s/files/1/0109/0663/2256/files/refresh-Icon.svg?v=1687516462">';
      measure_data_r += '</a>';
      measure_data_r += '</div>';
      measure_data_r += '</div>';
      measure_data_result_add.html(measure_data_r);
      var perfect_fit_data = ``;
      perfect_fit_data += '<div class="perfect-fit-heading-main">';
      perfect_fit_data += '<h5 class="text-md">Your Perfect Fit</h5>';
      perfect_fit_data += '<p class="text-xs"><img src="https://cdn.shopify.com/s/files/1/0109/0663/2256/files/Icon_1.png?v=1688368477"> Perfect Fit</p>';
      perfect_fit_data += '</div>';
      perfect_fit_data += '<div class="perfect-fit-details">';
      perfect_fit_data += '<div class="product-variant">';
      perfect_fit_data += '<div class="item-variant">';
      perfect_fit_data += '<span class="vatiany-title text-sm">Size</span>';
      perfect_fit_data += '<span class="vatiany-value h4">4</span>';
      perfect_fit_data += '</div>';
      perfect_fit_data += '</div>';
      perfect_fit_data += '<div class="best-fit-text text-sm">BEST FIT</div>';
      perfect_fit_data += '</div>';
      measure_fit_data_result_add.html(perfect_fit_data);



      this.container.html(x);

    var aray = this.popup.template.data.media;
      var sliderHtml = '';
      aray.forEach(function(item,index){
        if(item.src == undefined){
        }
        else{
        sliderHtml += `<div class='slide_items'><img src='${item.src}'></div>`;  
        }
      });
      var newElement = document.createElement('div');
      newElement.innerHTML = sliderHtml;
      newElement.classList.add('measure-product-images-slider');
      $('.product-left-images').html(newElement);
  },

  onMeasurementChange: function(e) {
    var valuessss = parseFloat(e.target.value);
    if(e.type == "keypress"){
      validateKeyPress(e);
    }


    function validateKeyPress(event) {
      var keyCode = event.which ? event.which : event.keyCode;
      var inputValue = String.fromCharCode(keyCode);
    
      // Check if the input value is a digit
      if (!/\d/.test(inputValue)) {
        event.preventDefault(); // Prevent entering non-digit characters
        return;
      }
    
      var value = parseFloat(inputValue);
      var currentInput = event.target.value + inputValue;
    
      // Check if the current input is negative or exceeds two digits
      if (value < 0 || currentInput.length > 2) {
        event.preventDefault(); // Prevent entering negative numbers or more than two digits
      }
    }



    var measures = this.getMeasurePoints();
    var mesure_title = measures;
    var mesurment;
    var m = [];
    var size = [];
    for(var i = 0; i < measures.length; i++) {
      mesurment = measures[i];
      var m = mesurment.escapeHTML();
      var mesurement_val;
      mesurement_val = $(`.c-measure-popup__input[data-measurement="${mesurment}"]`).val();
      var m_title = mesurment.split(" ");
      size.push({[m_title[0]] : mesurement_val});
      // $(".upper-size p").html(UpperSize);
      // var LowerSize = $('.c-measure-popup__input[data-measurement="Lower Circumference"]').val();
      // $(".lower-size p").html(LowerSize);
    }
    var size_html;
size.forEach((element) => {
    for (var key in element) {
      if (element.hasOwnProperty(key)) {
        size_html += `<p class='text-lg'>${element[key]} cm - ${key}</p>`;
      }
    }
});
    $(".measurment-size-wrapper .left-size-info .actual-size").html(size_html.replace('undefined',''));
    //Get element and value
    var self = $(e.currentTarget);
    var msr = self.attr('data-measurement');
    //to fixed function , set input field to 1 dp then validate it. .toFixed();

    //Store setting
    this.settings[msr] = self.val();

    //Update button state(s)
    $('[data-measure-step-next]').each(function(i,e) {
      var btn = $(e);
      var btnMsr = btn.attr('data-measurement');
      var hasMsr = this.settings[btnMsr];
      if(hasMsr && hasMsr != '' && hasMsr.replace(/\s/gi).length) {
        hasMsr = parseFloat(hasMsr);
        if(isNaN(hasMsr) || !isFinite(hasMsr) || hasMsr < 0) hasMsr = null;
      } else {
        hasMsr = null;
      }

      if(hasMsr) {
        btn.removeClass('is-disabled');
        btn.removeAttr('disabled');
      } else {
        btn.addClass('is-disabled');
        btn.attr('disabled', 'disabled');
      }
    }.bind(this));

    // var UpperSize = $('.c-measure-popup__input[data-measurement="Upper Circumference"]').val();
    //   $(".upper-size p").html(UpperSize);
    //   var LowerSize = $('.c-measure-popup__input[data-measurement="Lower Circumference"]').val();
    //   $(".lower-size p").html(LowerSize);

  },

  onNextClick: function(e) {
    this.next();
  },

  onPrevClick: function(e) {
    this.prev();
  },

  refreshCarousel: function() {
    if(!this.container) return;
    this.container.slick('slickSetOption', 'arrows', 'false', true);
    this.container.slick('setPosition', this.step);
  },

  onResize: function(e) { this.refreshCarousel(); },
  onAfterChange: function(e) { setTimeout(this.refreshCarousel.bind(this), 16); }
});


/*

 *  Customer Reviews Carousel

 *    Scripts and logic for the reviews carousel.

 *

 *  Dependencies:

 *    slick - Slick is required to run the carousel itself

 *    jQuery - jQuery is required for event listeners

 *    sections/customer-reviews.liquid - Required for building the collection carousel.

 *

 *  Version:

 *    1.0.0 - 2019/10/03

 */



var REVIEW_CAROUSEL_SELECTOR = '[data-reviews-carousel]';

var REVIEW_CAROUSEL_LOOP_SELECTOR = '[data-reviews-carousel-loop]';

var REVIEW_CAROUSEL_SECTION_SELECTOR = '.c-section__customer-reviews';



 // hack to make the first and last slide transparent

$(REVIEW_CAROUSEL_LOOP_SELECTOR).on('mousedown', function(){

  var allSlides = $(REVIEW_CAROUSEL_LOOP_SELECTOR).find('.slick-slide');

  allSlides.css('opacity','1');

});

$(REVIEW_CAROUSEL_LOOP_SELECTOR).on('mouseup', function(){

  var lastSlide = $(REVIEW_CAROUSEL_LOOP_SELECTOR).find('.slick-slide').last().next();

  lastSlide.css('opacity','.5');

});



$(REVIEW_CAROUSEL_LOOP_SELECTOR).on('beforeChange', function(event, slick, currentSlide, nextSlide){

  var allSlides = $(REVIEW_CAROUSEL_LOOP_SELECTOR).find('.slick-slide');

  allSlides.css('opacity','1');

});

$(REVIEW_CAROUSEL_LOOP_SELECTOR).on('afterChange', function(event, slick, currentSlide, nextSlide){

  var lastSlide = $(REVIEW_CAROUSEL_LOOP_SELECTOR).find('.slick-slide').last().next();

  lastSlide.css('opacity','.5');

});



function ReviewCarousel(container) {

  this.container = container;

  this.id = container.attr('data-id');



  var options = {

    infinite: this.container.attr('data-infinite') == 'true',

    slidesToShow: 1,

    slidesToScroll:  1,

    autoplay: this.container.attr('data-autoplay') == 'true',

    dots: false,

    arrows: !!this.container.attr('data-arrows'),

    adapativeHeight: 'true',

    autoplaySpeed: parseInt(this.container.attr('data-autoplay-speed')) * 1000 || 5000,

    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',

    responsive: [

    {

        breakpoint: 751,

        settings: {

          slidesToShow: 1,

          slidesToScroll: 1,

          arrows: false,

          dots: true

        }

      }

    ]

  };



  this.slick = this.container.slick(options);

  window.reviewCarousel[this.id] = this;

}



ReviewCarousel.prototype = {

  remove: function() {

    this.container.remove();

  },



  setSlide: function(slide) {

    this.container.slick('slickGoTo', slide);

  }

}



window.reviewCarousel = window.reviewCarousel || {};



$(document).ready(function() {

  $(REVIEW_CAROUSEL_LOOP_SELECTOR).each(function() {

    var self = $(this);

    if(window.reviewCarousel[self.data('id')]) return;

    if(self.hasClass('slick-initialized')) return;

    new ReviewCarousel(self);

  });

});



// SECTION EVENTS

$(document).on('shopify:section:load', REVIEW_CAROUSEL_SECTION_SELECTOR, function(e) {

  var id = e.detail.sectionId;

  var carousel = window.reviewCarousel[id];

  if(typeof carousel !== typeof undefined) {

    carousel.remove();

  }

  carousel = new CollectionCarousel($(REVIEW_CAROUSEL_SECTION_SELECTOR + '[data-id="'+id+'"]'));

});



$(document).on('shopify:section:unload', REVIEW_CAROUSEL_SECTION_SELECTOR, function(e) {

  var id = e.detail.sectionId;

  var carousel = window.collectionCarousels[id];

  if(typeof carousel === typeof undefined) return;

  carousel.remove();

});
function ShopByDots(container) {
  var DOT_SELECTOR = '[data-promo-feature-dot]';

  this.container = container;
  this.container.on('click', DOT_SELECTOR, this.onDotClicked.bind(this));
}

function isMobile() {
  return $(window).width() < 750;
}

ShopByDots.prototype = Object.assign(ShopByDots.prototype, {
  onDotClicked: function(e) {
    if(!isMobile()) return;
    
    if(!$(e.target).is('a'))
      e.preventDefault();

    var TEXT_SELECTOR = '[data-promo-feature-mobile-text]';
    var CLASS_ACTIVE = 'is-active';

    var self = $(e.currentTarget);
    var text = self.find(TEXT_SELECTOR);

    if(self.is(this.lastClicked)) {
      text.toggleClass(CLASS_ACTIVE);
      return;
    }

    this.lastClicked = self;
    this.container.find(TEXT_SELECTOR).removeClass(CLASS_ACTIVE);
    text.toggleClass(CLASS_ACTIVE);
  }
});

$(document).ready(function() {
  var SHOP_BY_DOTS_SELECTOR = '[data-promo-feature-dots]';
  $(SHOP_BY_DOTS_SELECTOR).each(function(idx, el) {
    new ShopByDots($(el));
  })
});

/*================ Templates ================*/
/*
 *  Addresses Page
 *    Scripts for Addresses Page
 *
 *  Dependencies:
 *    jQuery - jQuery is required for event listeners
 *    scripts/tools/language.js - Required for messasges.
 *
 *
 *  Version:
 *    1.0.0 - 2018/02/21
 */
if($('[data-address-template]').length) {
  window.Language.required('customer.addresses.delete_confirm');
}

//Address Create
$(document).on('click', '[data-address-create-toggle]', function(e) {
  e.preventDefault();

  var self = $(this);
  $('[data-address-create-form]').toggleClass('is-visible');
});

$(document).on('click', '[data-address-create-show]', function(e) {
  e.preventDefault();

  var self = $(this);
  $('[data-address-create-form]').addClass('is-visible');
});

$(document).on('click', '[data-address-create-hide]', function(e) {
  e.preventDefault();

  var self = $(this);
  $('[data-address-create-form]').removeClass('is-visible');
});

//Address Edit
$(document).on('click', '[data-address-edit-toggle]', function(e) {
  e.preventDefault();

  var self = $(this);
  if(typeof self.data('index') === typeof undefined) {
    var target = self.closest('[data-address-edit-form]');
  } else {
    var target = $('[data-address-edit-form][data-index="'+self.data('index')+'"]');
  }
  target.toggleClass('is-visible');
});

$(document).on('click', '[data-address-edit-show]', function(e) {
  e.preventDefault();

  var self = $(this);
  if(typeof self.data('index') === typeof undefined) {
    var target = self.closest('[data-address-edit-form]');
  } else {
    var target = $('[data-address-edit-form][data-index="'+self.data('index')+'"]');
  }
  target.addClass('is-visible');
});

$(document).on('click', '[data-address-edit-hide]', function(e) {
  e.preventDefault();

  var self = $(this);
  if(typeof self.data('index') === typeof undefined) {
    var target = self.closest('[data-address-edit-form]');
  } else {
    var target = $('[data-address-edit-form][data-index="'+self.data('index')+'"]');
  }
  target.removeClass('is-visible');
});

//Address Delete
$(document).on('click', '[data-address-delete]', function(e) {
  var self = $(this);
  var id = self.data('id');
  if(!id) return;
  if (confirm(window.Language.get('customer.addresses.delete_confirm'))) {
    Shopify.postLink('/account/addresses/' + id, {parameters: {_method: 'delete'}});
  }
});

/*
 *  Blog Template
 *    Scripts for the infinite scroll blog template
 *
 *  Dependencies:
 *    jQuery
 *    templates/blog.ajax-list.liquid
 *
 *  Version:
 *    1.0.0 - 2018/08/02
 */
function BlogTemplate(container) {
  this.container = container;
  this.articleContainer = container.find('[data-blog-template-blogs]');
  this.loadMore = container.find('[data-blog-template-load-more]');
  this.count = container.attr('data-count') || 10;
  this.filter = container.find('[data-blog-template-filter]');

  //Locate the articles container
  this.viewMore = this.container.find('[data-view-more]');
  this.page = 1;

  this.pendingRequest = null;

  //Existing articles?
  this.existingData = container.find('[data-blog-template-json]');
  if(this.existingData.length) {
    var raw = this.existingData.html();
    try {
      raw = JSON.parse(raw);
    } catch(e) {
      console.error(e);
      return;
    }
    this.parseJSON(raw, this.page || 1);
  }

  this.container.on('click', '[data-blog-template-load-more]', this.fetchNext.bind(this));
  this.container.on('change', '[data-blog-template-filter]', this.onFilter.bind(this));


  this.container.find('[data-carousel-slider]').not('.slick-initialized').slick({
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: false,
    infinite: true,
    speed: 500,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  this.container.on('click', '[data-carousel-nav-next]', function(e) {
    $('[data-carousel-slider]').slick("slickNext");
  });
  this.container.on('click', '[data-carousel-nav-prev]', function() {
    $('[data-carousel-slider]').slick("slickPrev");
  });

  this.showHideNavArrows();
  $(window).on('resize', this.showHideNavArrows.bind(this));
}

BlogTemplate.prototype = {
  showHideNavArrows: function() {
    var slideCount = $('[data-carousel-slider]').slick('getSlick').slideCount;

    /* Depending on screen size and slide count, hide arrows */
    if(
      window.matchMedia('(min-width: 1250px)').matches && slideCount <= 5 ||
      window.matchMedia('(min-width: 501px)').matches && slideCount <= 3 ||
      slideCount <= 1
    ) {
      $('[data-carousel-arrow-container]').hide();
      return;
    }
    $('[data-carousel-arrow-container]').show();
  },

  onFilter: function() {
    var value = this.filter.val();
    var optionElement = this.container.find('[data-tag="'+value+'"]');
    var link = optionElement.attr('data-link');
    window.location.href = link;
  },

  getBaseURL: function() {
    var url = window.location.pathname;
  },

  fetchNext: function() {
    this.fetchPage(this.page + 1);
  },

  isPrinted: function(id) {
    return this.container.find('[data-article-id="'+id+'"]').length;
  },

  fetchPage: function(page) {
    if(page <= 0) return;
    if(this.pendingRequest != null) return;//Already pending
    var params = {
      view: 'json',
      page: page
    };

    var requestParams = {
      template: this,
      params: params
    };

    var request = $.ajax({
      url: this.getBaseURL(),
      data: params,
      method: 'GET',
      error: this.onError.bind(requestParams),
      success: this.onData.bind(requestParams)
    });
    requestParams.request = request;
    this.pendingRequest = request;
  },

  onError: function(e, a, b) {
    this.pendingRequest = null;
    console.error(e);
    console.error(a);
    console.error(b);
  },

  onData: function(e) {
    this.template.pendingRequest = null;
    this.dataRaw = e;
    this.data = JSON.parse(e);
    this.template.parseJSON(this.data, this.params.page);
  },

  parseJSON: function(json, page) {
    this.data = json.blog;
    this.page = page;
    for(var i = 0; i < json.articles.length; i++) {
      var article = json.articles[i];
      if(this.isPrinted(article.id)) continue;
      this.articleContainer.append(article.data);
    }
    if(json.articles.length < this.count) {
      this.onArticlesFetched();
    }
  },

  onArticlesFetched: function() {
    this.loadMore.css('display', 'none');
  }
};

//Instances..
$(document).ready(function() {
  $('[data-blog-template]').each(function(e) {
    var self = $(this);
    new BlogTemplate(self);
  });
});

/*
 *  Cart Template
 *    Scripts for the cart page template.
 *
 *  Dependencies:
 *    jQuery
 *    scripts/tools/cart.js
 *    scripts/tools/currency.js
 *    scripts/objects/_cart-quantity-selector.js
 *    scripts/objects/_quantity-selector.js
 *    templates/cart.page-ajax.liquid
 *
 *  Version:
 *    1.0.0 - 2018/08/01
 */
function CartTemplate(container) {
  this.container = container;
  this.form = container.find('[data-cart-page-form]');
  this.loader = container.find('[data-cart-page-loader]');
  this.body = container.find('[data-cart-page-body]');

  $(document).on('onCartPending', this.onCartPending.bind(this));
  $(document).on('onCartUpdate', this.onCartUpdate.bind(this));
  this.container.on('submit', '[data-cart-page-form]', this.onSubmit.bind(this));
  // this.container.on('click', '[data-cart-page-remove-item]', this.onRemove);
}

CartTemplate.prototype = {
  onCartPending: function() {
    this.container.addClass('is-loading');
  },

  onCartUpdate: function(e, data) {
    if(data.items.length > 2){
      $(".c-template-cart .checkout-button").addClass("Active");
    }else{
      $(".c-template-cart .checkout-button").removeClass("Active");
    }
    if(data.items.length < 1) {
      return window.location.reload();
    }
    this.fetchAndPrint();
  },
  onRemove: function(e) {
    e.preventDefault();
    e.stopPropagation();
    var self = $(this);
    var index = self.attr('data-line-index');
    window.Cart.remove(index);
  },

  fetchAndPrint: function() {
    var o = {
      url: '/cart',
      data: {
        view: 'page-ajax'
      }
    };
    o.self = this;
    o.success = this.onPrintData.bind(o);
    o.error = this.onPrintError.bind(o);
    var request = $.ajax(o);
    o.request = request;

    this.lastRequest = request;
  },

  onPrintData: function(data) {
    //Take the raw cart data and print the correct information onto the ajax cart
    this.self.container.removeClass('is-loading');
    if(typeof data === typeof undefined || !data.length) {
      //TODO: Add an error handler
      return this.self.onPrintError.bind(this)(data);
    }

    this.self.body.html(data);
    this.self.container.find('[data-cart-quantity-selector]').each(function(e, i) {
      var selector = new CartQuantitySelector($(i));
    });
    this.self.body.trigger('onMoneyChange');
  },

  onPrintError: function(e, i, a, b) {
    console.log(e);
    console.log(i);
    console.log(a);
    console.log(b);
    this.self.list.html('<p>error</p>');
  },

  onSubmit: function() {
  }
};

$(document).ready(function() {
  $('[data-cart-page]').each(function() {
    var self = $(this);
    window.cartTemplate = new CartTemplate(self);
  });
});

/*
 *  Collection Template
 *
 *
 *  Dependencies:
 *    scripts/components/AjaxCollection
 *
 *  Version:
 *    1.0.0 - 2018/07/20
 */
function CollectionTemplate(container) {
  //Let's call the AjaxCollection function super
  AjaxCollection.call(this, container);

  //First set initial mode
  this.displayMode = 'first-available-variant';

  //Now mark the "no_matches" Language string as required, we need this from the
  //liquid so we know what to display when there's no results
  window.Language.required("collections.general.no_matches");

  /** Pagination **/
  this.pagination = new AjaxCollectionLoadMore(this, container);

  /** Filters **/

  //Collection Facet - Smart Tag Based
  this.collFacetCont = container.find('[data-collection-collection]');
  if(this.collFacetCont.length) {
    var collectionFilter = new AjaxCollectionTagFilter("collection", this, "OR");
    this.addFilter(collectionFilter);

    this.addFacet(new AjaxCollectionSmartTagFacet(
      this, collectionFilter, this.collFacetCont, "Type", "Filter"
    ));
  }

  //Filter By Need Facet - Smart Tag Based
  this.needContainer = container.find('[data-collection-need]');
  if(this.needContainer.length) {
    var needFilter = new AjaxCollectionTagFilter("need", this, "OR");
    this.addFilter(needFilter);

    this.addFacet(new AjaxCollectionSmartTagFacet(
      this, needFilter, this.needContainer, "Need", "Filter By Need"
    ));
  }

  //Filter By Use Facet - Smart Tag Based
  this.useContainer = container.find('[data-collection-use]');
  if(this.useContainer.length) {
    var useFilter = new AjaxCollectionTagFilter("use", this, "OR");
    this.addFilter(useFilter);

    this.addFacet(new AjaxCollectionSmartTagFacet(
      this, useFilter, this.useContainer, "Use", "Intended Use"
    ));
  }


  //Add our filters, we could use a group, but the default functionality for the
  //filters is AND based, so that's what we want in this case.


  /** Sorters **/
  this.attachSorter(container.find('[data-collection-sort-by]'));

  /** Begin **/
  this.start();//Start fetching products in the background;.
  this.draw();//FORCE A redraw, great for SEO.
  this.arrangeContentBlocks();


  // == End Ajax Collection Setup == //
  //Everything below this line is just for display reasons


  //Elements
  this.filterByPart = container.find('[data-collection-filter-part]');
  this.filterByPartToggle = container.find('[data-collection-toggle-filter-part]');
  this.filterByNeed = container.find('[data-collection-filter-need]');
  this.filterByNeedToggle = container.find('[data-collection-toggle-filter-need]');
  this.filterByUse = container.find('[data-collection-filter-use]');
  this.filterByUseToggle = container.find('[data-collection-toggle-filter-use]');

  this.collectionFilterToggle = container.find('[data-collection-toggle-filter]');
  this.collectionFilter = container.find('[data-collection-filter]');

  /** Event Handlers **/
  container.on('click', '[data-collection-template-toggle-filters]', this.toggleFilters.bind(this));
  container.on('click', '[data-collection-toggle-filter-part]', this.toggleFiltersPart.bind(this));
  container.on('click', '[data-collection-toggle-filter-need]', this.toggleFiltersNeed.bind(this));
  container.on('click', '[data-collection-toggle-filter-use]', this.toggleFiltersUse.bind(this));

  container.on('click', '[data-clear-filters]', this.onClearFilter.bind(this));

  //Hide inavtive filters.
  this.hideInactiveFilters();
}

CollectionTemplate.prototype = Object.assign(Object.assign({}, AjaxCollection.prototype), {
  onClearFilter: function(e) {
    for(var i = 0; i < this.filters.length; i++) {
      this.filters[i].setSettings([]);
    }
  },

  //CUSTOM
  isSaleCollection: function() {
    if(this.handle.indexOf('-sale') !== -1) return true;
    if(this.handle.indexOf('sale-') !== -1) return true;
    return this.handle == 'sale';
  },

  onProductsDrawn: function(drawn) {
    //window.Currency.updatePrices(); Removed for Plus non-Ajax update.
    if(!drawn || !drawn.length) {
      var x = '<span class="c-collection-template__sold-out-title">';
      x += Language.get("collections.general.no_matches").escapeHTML();
      x += '</span>';
      this.productContainer.html(x);
      //this.viewMoreButton.addClass('is-hidden');
    } else if(this.viewMoreProducts < this.unpaginatedProductCount) {
      //this.viewMoreButton.removeClass('is-hidden');
      this.container.find('.c-collection-template__sold-out-title').remove();

    } else {
      //this.viewMoreButton.addClass('is-hidden');
      this.container.find('.c-collection-template__sold-out-title').remove();
    }

    this.arrangeContentBlocks();
  },

  arrangeContentBlocks: function() {
    var thumbs = this.productContainer.find('[data-product-thumbnail]');
    var blocks =  this.productContainer.find('[data-collection-block]');

    //Count each thumb
    var x = 1;
    thumbs.each(function(i, e) {
      var self = $(e);

      //Find the elements at this index
      var target = this.productContainer.find('[data-collection-block-index="'+x+'"]');
      x = x + 1 + target.length;
      if(!target.length) return;

      target.insertAfter(self);
    }.bind(this));
  },

  toggleFilters: function(e) {
    e.stopPropagation();
    e.preventDefault();
    this.container.toggleClass('is-open');
    this.collectionFilter.addClass('is-hidden');
  },

  toggleFiltersPart: function(e) {
    e.stopPropagation();
    e.preventDefault();

    //Hide other filter & fade filter label
    this.filterByNeed.addClass('is-hidden');
    this.filterByNeedToggle.removeClass('is-open');
    this.filterByNeedToggle.toggleClass('is-inactive');
    this.filterByUse.addClass('is-hidden');
    this.filterByUseToggle.removeClass('is-open');
    this.filterByUseToggle.toggleClass('is-inactive');

    this.filterByPart.toggleClass('is-hidden');
    this.filterByPartToggle.toggleClass('is-open');
    this.filterByPartToggle.removeClass('is-inactive');
  },

  toggleFiltersNeed: function(e) {
    e.stopPropagation();
    e.preventDefault();

    //Hide other filter & fade filter label
    this.filterByPart.addClass('is-hidden');
    this.filterByPartToggle.removeClass('is-open');
    this.filterByPartToggle.toggleClass('is-inactive');
    this.filterByUse.addClass('is-hidden');
    this.filterByUseToggle.removeClass('is-open');
    this.filterByUseToggle.toggleClass('is-inactive');

    //Show this one
    this.filterByNeed.toggleClass('is-hidden');
    this.filterByNeedToggle.toggleClass('is-open');
    this.filterByNeedToggle.removeClass('is-inactive');
  },

  toggleFiltersUse: function(e) {
    e.stopPropagation();
    e.preventDefault();

    //Hide other filter & fade filter label
    this.filterByPart.addClass('is-hidden');
    this.filterByPartToggle.removeClass('is-open');
    this.filterByPartToggle.toggleClass('is-inactive');
    this.filterByNeed.addClass('is-hidden');
    this.filterByNeedToggle.removeClass('is-open');
    this.filterByNeedToggle.toggleClass('is-inactive');

    this.filterByUse.toggleClass('is-hidden');
    this.filterByUseToggle.toggleClass('is-open');
    this.filterByUseToggle.removeClass('is-inactive');
  },

  hideInactiveFilters: function() {
    var facetItem = '.c-faceted-nav__check-item';

    //If no filter by need, remove title.
    if(!this.needContainer.find(facetItem).length) {
      this.filterByNeedToggle.remove();
      this.filterByNeed.remove();
    }

    //If no filter by part, remove title.
    if(!this.collFacetCont.find(facetItem).length) {
      this.filterByPartToggle.remove();
      this.filterByPart.remove();
    }

    //If no filter by use, remove title
    if(!this.useContainer.find(facetItem).length) {
      this.filterByUseToggle.remove();
      this.filterByUse.remove();
    }
  },

  generatePrint: function(variant, i) {
    var v = variant;
    var p = variant.product;

    var image = null;
    if(v.featured_image && v.featured_image.src) {
      image = v.featured_image.src;
    } else {
      image = p.image;
    }

    var colorIndex = this.getOptionIndex(p, ['color', 'colour']);

    //Assign Metafield Data
    var productSubheading = '';
    var descriptionExcerpt = '';
    var okendoReviewsSummary = '';

    if(p.productSubheading != null) productSubheading = p.productSubheading;
    if(p.descriptionExcerpt != null) descriptionExcerpt = p.descriptionExcerpt;
    if(p.okendoReviewsSummary != null) okendoReviewsSummary = p.okendoReviewsSummary;

    //Now we can generate
    var x = '';

    //Wrapper
    x += '<div ';
    x += 'class="'
    x += 'o-product-thumbnail__container ';
    x += 'o-product-thumbnail__container--style-color ';
    x += '" data-product-thumbnail ';
    x += 'data-product-handle="'+p.handle+'" data-product-id="'+p.id+'" ';
    x += 'data-variant-id="'+v.id+'" ';
    x += 'itemprop="itemListElement" itemscope itemtype="http://schema.org/Product"';
    x += '>';

    x += '<a href="'+this.getVariantURL(variant)+'" class="o-product-thumbnail--style-color">';

    //Product Badges
    if(p.tags.indexOf('New') !== -1) {
      x += '<div class="o-badge o-badge__new">'+Language.strings['products.product.badge_new']+'</div>';
    } else if (p.tags.indexOf('Best Seller') !== -1) {
      x += '<div class="o-badge o-badge__best-seller">'+Language.strings['products.product.badge_best_seller']+'</div>';
    };

    //Meta Info
    x += '<meta itemprop="name" content="';
    x += p.title.escapeHTML() + (p.variants.length != 1 ? ' - ' + v.title.escapeHTML() : '');
    x += '" />';
    x += '<meta itemprop="url" content="'+window.location.origin+v.url+'" />';
    x += '<meta itemprop="brand" content="'+p.vendor.escapeHTML()+'" />';
    //META Image
    //Desc

    //Image and sizer
    x += '<span class="u-box-sizer--moz-fix o-product-thumbnail__image-container--style-color">';
    x += ImageTools.generatePicture(
      image,
      500,
      [150,250,500],
      'o-product-thumbnail__image o-product-thumbnail__image--style-color',
      v.featured_image ? ( v.featured_image.alt || v.title ).escapeHTML() : v.title.escapeHTML()
    );
    x += '</span>';

    //Title
    x += '<span class="o-product-thumbnail__footer--style-color">';
    x += '<div class="o-product-thumbnail__footer--title-container">';
    x += '<h3 class="o-product-thumbnail__title--style-color">';
    x += p.title.escapeHTML();
    x += '</h3>';

    //Subheading
    if(productSubheading != '') {
      x += '<p class="o-product-thumbnail__subheading">';
      x += productSubheading;
      x += '</p>'
    }

    //Price
    if(v.compare_at_price && v.compare_at_price > v.price) {
      x += '<span class=" o-product-thumbnail__money--style-color';
      x += ' o-product-thumbnail__money-compare--style-color" data-currency';
      x += 'data-money="{{ variant.compare_at_price }}" >';
      x += Currency.formatMoney(v.compare_at_price);
      x += '</span> ';
    }

    x += '<span class="o-product-thumbnail__money--style-color" data-currency data-money="'+v.price+'">';
    x += Currency.formatMoney(v.price);
    x += '</span>';

    //Okendo Reviews???
    x += '<div data-oke-reviews-product-listing-rating class="o-product-thumbnail__rating">'+okendoReviewsSummary+'</div>';

    //Description Excerpt
    x += '<div class="o-product-thumbnail__description-excerpt">';
    x += descriptionExcerpt;
    x += '</div>'

    x += '<span class="o-btn o-product-thumbnail__buy-now">';
    x += Language.strings['products.product.buy_now'];
    x += '<span class="o-btn__arrow c-content-features__btn-arrow">'
    x += '<svg viewBox="0 0 32 18" class="icon icon-arrow-right--blue" version="1" xmlns="http://www.w3.org/2000/svg">';
    x += '<path fill="#20bad6" d="M23 0l-2 2 6 6H0v2h27l-6 6 2 2 9-9z"/>';
    x += '</svg>';

    x += '</span>';

    x += '</span>';

    var color;

    x += '</div>';

    x += '</span>';

    x += '</a>';

    x += '</div>';

    return x;
  },

  onProductsFiltered: function() {
    var isFiltering = false;
    for(var i = 0; i < this.filters.length; i++) {
      var f = this.filters[i];
      var filterValue = f.getSettings();
      if(!filterValue || !filterValue.length) continue;
      isFiltering = true;
      break;
    }

    if(isFiltering) {
      this.container.addClass('is-filtering');
    } else {
      this.container.removeClass('is-filtering');
    }
  }
});

//Register
window.collectionTemplates = window.collectionTemplates || [];

$(document).ready(function() {
  $('[data-collection-template]').each(function(e, i) {
    var self = $(this);
    var template = new CollectionTemplate(self);
    window.collectionTemplates.push(template);
    window.test = template;
  });
});

//Read More for collection description
$("[data-collection-read-more]").click(function() {
  $ ('[data-collection-description]').addClass('is-visible');
  $ ('[data-collection-read-more').removeClass('is-visible');
  $ ('[data-collection-read-less').addClass('is-visible');
});
$("[data-collection-read-less]").click(function() {
  $ ('[data-collection-description]').removeClass('is-visible');
  $ ('[data-collection-read-more').addClass('is-visible');
  $ ('[data-collection-read-less').removeClass('is-visible');
});

$(document).on('click', '[data-login-form-forgot-password]', function(e) {
  $('[data-registration-form]').toggleClass('is-visible');  
});

$(document).on('submit', 'form#create_customer', function(e) {
  var PASSWORD_SELECTOR = '[data-password]';
  var PASSWORD_CONFIRMATION_SELECTOR = '[data-password-confirmation]';
  var PASSWORD_CONFIRMATION_ERROR_SELECTOR = '[data-password-confirmation-error]';
  var CLASS_VISIBLE = 'is-visible';
  
  var form = $(e.target);
  var password = form.find(PASSWORD_SELECTOR);
  var passwordConfirmation = form.find(PASSWORD_CONFIRMATION_SELECTOR);
  var passwordConfirmationSelector = form.find(PASSWORD_CONFIRMATION_ERROR_SELECTOR);

  if(password.val() !== passwordConfirmation.val()) {
    passwordConfirmationSelector.addClass(CLASS_VISIBLE)
    e.preventDefault();
  }
})
/*
 *  Product Template
 *    Contains logic for the product template.
 *
 *  Dependencies:
 *    scripts/objects/_variant-selector.js
 *    scripts/objects/cart.js
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
function ProductTemplate(container) {
  this.container = container;

  //Load in product data
  this.data = JSON.parse(container.find('[data-product-json]').html());

  //Setup Motion is Life Popup
  this.popup = window.popup = new ProductMeasurePopup(this);

  //Event Handlers
  this.qtySelector = this.container.find('[name="quantity"]');
  this.container.on('click', '[data-description-read-more]', this.scrollToDescription.bind(this));
  this.container.on('click', '[data-show-measure-popup]', this.onShowMeasurePopup.bind(this));
  this.container.on('click', '[data-close-measure-popup]' , this.onCloseMeasurePopup.bind(this));
  this.container.on('keypress keydown keyup', '[data-product-page-form]', this.onEnter.bind(this));
  //this.container.on('click touchstart', '.c-product-template__rating', this.scrollToReviews.bind(this));
}

ProductTemplate.prototype = Object.assign(ProductTemplate.prototype, {
  scrollToDescription: function(e) {
    $('html,body').animate({
      scrollTop: $("[data-accord-description]").offset().top
    },'slow');
  },

  scrollToReviews: function(e) {
    //Currently unused
    $('html, body').animate({
      scrollTop: $('[data-product-review-testimonials]').offset().top
    }, 1000);
  },

  onShowMeasurePopup: function(e) {
    this.popup.show();
  },

  onCloseMeasurePopup: function() {
    this.popup.close();
  },

  onEnter: function(e) {
    if (e.keyCode === 10 || e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
});

$(document).ready(function() {
  $('[data-product-page]').each(function(e, i) {
    window.template = new ProductTemplate($(this));
  });
});

/*
 *  Search Template
 *    Scripts for the search template ajax functionality.
 *
 *  Dependencies:
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/08/03
 */
function SearchTemplate(container) {
  this.container = container;
  this.form = container.find('[data-search-template-form]');
  this.results = container.find('[data-search-template-results]');

  //TODO: Support Ajax submissions
  this.container.on('submit', '[data-search-template-form]', this.doSearch.bind(this));
}

SearchTemplate.prototype = {
  doSearch: function(e) {
    this.container.addClass('is-loading');
  }
}


$(document).ready(function() {
  $('[data-search-template]').each(function() {
    var self = $(this);
    new SearchTemplate(self);
  });
});

/*
 *  Technology Template
 *    Scripts for the technology templates.
 *
 *  Dependencies:
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/08/03
 */

(function () {
  var CLASS_HIDDEN = 'hidden';
  var LEG_WRAPPER_SELECTOR = '[data-technology-leg-wrapper]';
  var LEG_SELECTOR = '[data-technology-leg]';
  var LEG_SUB_SELECTOR = '[data-technology-leg-subcomponent]';
  var LEG_SUB_VISIBLE_TIMEOUT = 500;

  function TechnologyTemplate(container) {
    this.container = container;
    this.legWrapper = container.find(LEG_WRAPPER_SELECTOR);
    this.legEquipment = container.find(LEG_SELECTOR);
    if(this.legEquipment.length > 1) return;
    this.legEquipmentSubcontents = this.legEquipment.find(LEG_SUB_SELECTOR);
  
    this.legEquipment.addClass(CLASS_HIDDEN);
    this.legEquipmentSubcontents.addClass(CLASS_HIDDEN);

    this.onScroll.bind(this)();
    $(window).on('scroll', this.onScroll.bind(this));
  }
  
  TechnologyTemplate.prototype = {
    isScrolledTo: function(elem) {
      //Have we scrolled to the element?
      var docViewTop = $(window).scrollTop(); //num of pixels hidden above current screen
      var docViewBottom = docViewTop + $(window).height();
      var elemTop = $(elem).offset().top; //num of pixels above the elem
      // var elemMiddle = elemTop + (elem.innerHeight() / 2);
      if(elemTop > docViewBottom) return false;//Below bottom of screen
      return true;
    },
  
    onScroll: function() {
      if(this.isScrolledTo(this.legWrapper)) {
        this.legEquipment.removeClass(CLASS_HIDDEN);
        this.legEquipmentSubcontents.each(function(idx, el) {
          var legEquipmentSubcontent = $(el);
          setTimeout(() => {
            legEquipmentSubcontent.removeClass(CLASS_HIDDEN);
          }, (idx + 1) * LEG_SUB_VISIBLE_TIMEOUT);
        })
      }
    }
  }
  
  $(document).ready(function() {
    $('[data-technology]').each(function() {
      var self = $(this);
      new TechnologyTemplate(self);
    });
  });
})();

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}




$(document).ready(function() {
  if($(".c-page--product").length > 0){
    document.querySelector(".zoom_btn").addEventListener("click", function() {
      document.querySelector(".c-product-carousel__slide.slick-active a").click();
    });
      Fancybox.bind("[data-fancybox]", {
      mainClass : "main_product_image_zoombox",
      btnTpl:{
        close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
        '<i class="fas fa-times"></i>' +
        "</button>"
      }, 
      Thumbs : {
      type: "classic"
      },
      iframe: {
        preload: false 
      }
      });
    }
  });







// popup tab event prevent
$('body').bind('keydown', function(e){
if($('body.c-page--product').hasClass('is-popup-open')){
if(e.keyCode == '9' || e.keyCode == '37' || e.keyCode == '38' || e.keyCode == '39'|| e.keyCode == '40' ){
    return false;
}
}else{ }
});